import type { LocaleCode } from './catalog'

/** M6: full copy for all 8 platform locales; missing keys still fall back. */
export const messages: Record<string, Partial<Record<LocaleCode, string>>> = {
  'nav.intro': {
    'zh-TW': '介紹', 'zh-CN': '介绍', en: 'Intro', id: 'Intro', vi: 'Giới thiệu', th: 'แนะนำ', ja: '紹介', ko: '소개',
  },
  'nav.pricing': {
    'zh-TW': '方案', 'zh-CN': '方案', en: 'Pricing', id: 'Harga', vi: 'Bảng giá', th: 'ราคา', ja: '料金', ko: '요금',
  },
  'nav.auth': {
    'zh-TW': '登入', 'zh-CN': '登录', en: 'Sign in', id: 'Masuk', vi: 'Đăng nhập', th: 'เข้าสู่ระบบ', ja: 'ログイン', ko: '로그인',
  },
  'nav.manageSites': {
    'zh-TW': '我的網站', 'zh-CN': '我的网站', en: 'My websites', id: 'Situs saya', vi: 'Website của tôi', th: 'เว็บไซต์ของฉัน', ja: 'マイサイト', ko: '내 웹사이트',
  },
  'nav.menu': {
    'zh-TW': '選單', 'zh-CN': '菜单', en: 'Menu', id: 'Menu', vi: 'Menu', th: 'เมนู', ja: 'メニュー', ko: '메뉴',
  },
  'nav.openMenu': {
    'zh-TW': '開啟選單', 'zh-CN': '打开菜单', en: 'Open menu', id: 'Buka menu', vi: 'Mở menu', th: 'เปิดเมนู', ja: 'メニューを開く', ko: '메뉴 열기',
  },
  'nav.closeMenu': {
    'zh-TW': '關閉選單', 'zh-CN': '关闭菜单', en: 'Close menu', id: 'Tutup menu', vi: 'Đóng menu', th: 'ปิดเมนู', ja: 'メニューを閉じる', ko: '메뉴 닫기',
  },
  'hero.eyebrow': {
    'zh-TW': 'mybo.net', 'zh-CN': 'mybo.net', en: 'mybo.net', id: 'mybo.net', vi: 'mybo.net', th: 'mybo.net', ja: 'mybo.net', ko: 'mybo.net',
  },
  'hero.title': {
    'zh-TW': '一個帳號，經營多個品牌網站', 'zh-CN': '一个账号，经营多个品牌网站', en: 'One account, many brand websites', id: 'Satu akun, banyak merek', vi: 'Một tài khoản, nhiều thương hiệu', th: 'หนึ่งบัญชี หลายแบรนด์', ja: '1つのアカウントで複数ブランド', ko: '계정 하나로 여러 브랜드',
  },
  'hero.lead': {
    'zh-TW': '在 mybonet 註冊一次，就能依方案建立多個品牌網站，每個網站立刻擁有專屬網址（例如 shop.mybo.net）。從這裡統一管理，再進入各網站的後台編輯內容與外觀。',
    'zh-CN': '在 mybonet 注册一次，就能按方案建立多个品牌网站，每个网站立刻拥有专属网址。从这里统一管理，再进入各网站后台编辑内容与外观。',
    en: 'Sign up once on mybonet, create multiple brand sites by plan, each with its own address like shop.mybo.net. Manage everything here, then open each site studio to edit content and look.',
    id: 'Daftar sekali di mybonet, buat banyak situs merek, masing-masing punya alamat sendiri. Kelola di sini, lalu buka studio tiap situs.',
    vi: 'Đăng ký một lần trên mybonet, tạo nhiều website thương hiệu theo gói, mỗi site có địa chỉ riêng. Quản lý tại đây rồi vào studio từng site.',
    th: 'สมัครครั้งเดียวบน mybonet สร้างหลายเว็บแบรนด์ตามแพ็กเกจ แต่ละเว็บมีที่อยู่ของตัวเอง จัดการที่นี่แล้วเข้าสตูดิโอของแต่ละเว็บ',
    ja: 'mybonet に一度登録すれば、プランに応じて複数のブランドサイトを作成でき、それぞれ専用アドレスが付きます。ここでまとめて管理し、各サイトの編集画面へ進めます。',
    ko: 'mybonet에 한 번 가입하면 요금제에 따라 여러 브랜드 사이트를 만들고 각각 전용 주소를 받습니다. 여기서 통합 관리한 뒤 각 사이트 편집실로 들어가세요.',
  },
  'hero.ctaStart': {
    'zh-TW': '開始註冊', 'zh-CN': '开始注册', en: 'Get started', id: 'Mulai', vi: 'Bắt đầu', th: 'เริ่มต้น', ja: 'はじめる', ko: '시작하기',
  },
  'hero.ctaPricing': {
    'zh-TW': '看方案與價格', 'zh-CN': '看方案与价格', en: 'See pricing', id: 'Lihat harga', vi: 'Xem giá', th: 'ดูราคา', ja: '料金を見る', ko: '요금 보기',
  },
  'pricing.title': {
    'zh-TW': '方案', 'zh-CN': '方案', en: 'Pricing', id: 'Harga', vi: 'Bảng giá', th: 'ราคา', ja: '料金', ko: '요금',
  },
  'pricing.loading': {
    'zh-TW': '載入定價中…', 'zh-CN': '加载定价中…', en: 'Loading pricing…', id: 'Memuat harga…', vi: 'Đang tải…', th: 'กำลังโหลด…', ja: '読み込み中…', ko: '불러오는 중…',
  },
  'pricing.perMonth': {
    'zh-TW': 'USD / 月', 'zh-CN': 'USD / 月', en: 'USD / mo', id: 'USD / bln', vi: 'USD / tháng', th: 'USD / เดือน', ja: 'USD / 月', ko: 'USD / 월',
  },
  'pricing.yearly': {
    'zh-TW': '年付', 'zh-CN': '年付', en: 'Yearly', id: 'Tahunan', vi: 'Năm', th: 'รายปี', ja: '年額', ko: '연간',
  },
  'pricing.maxSites': {
    'zh-TW': '個網站', 'zh-CN': '个网站', en: 'websites', id: 'situs', vi: 'website', th: 'เว็บไซต์', ja: 'サイト', ko: '웹사이트',
  },
  'pricing.addOns': {
    'zh-TW': '加購', 'zh-CN': '加购', en: 'Add-ons', id: 'Add-on', vi: 'Tiện ích thêm', th: 'ส่วนเสริม', ja: 'アドオン', ko: '애드온',
  },
  'auth.title': {
    'zh-TW': '註冊／登入', 'zh-CN': '注册／登录', en: 'Register / Sign in', id: 'Daftar / Masuk', vi: 'Đăng ký / Đăng nhập', th: 'สมัคร / เข้าสู่ระบบ', ja: '登録／ログイン', ko: '가입 / 로그인',
  },
  'auth.signedIn': {
    'zh-TW': '已登入', 'zh-CN': '已登录', en: 'Signed in', id: 'Sudah masuk', vi: 'Đã đăng nhập', th: 'เข้าสู่ระบบแล้ว', ja: 'ログイン済み', ko: '로그인됨',
  },
  'auth.hello': {
    'zh-TW': '你好，', 'zh-CN': '你好，', en: 'Hello, ', id: 'Halo, ', vi: 'Xin chào, ', th: 'สวัสดี, ', ja: 'こんにちは、', ko: '안녕하세요, ',
  },
  'auth.maxSites': {
    'zh-TW': '可建立最多', 'zh-CN': '可建立最多', en: 'You can create up to', id: 'Anda dapat membuat hingga', vi: 'Bạn có thể tạo tối đa', th: 'สร้างได้สูงสุด', ja: '作成上限', ko: '최대 생성',
  },
  'auth.maxSitesSuffix': {
    'zh-TW': ' 個品牌網站。點下方進入，即可新增網站或開啟編輯。', 'zh-CN': ' 个品牌网站。点下方进入，即可新增网站或开启编辑。', en: ' brand websites. Continue below to create or edit.', id: ' situs merek. Lanjut di bawah untuk membuat atau mengedit.', vi: ' website thương hiệu. Tiếp tục bên dưới để tạo hoặc chỉnh sửa.', th: ' เว็บแบรนด์ ดำเนินการด้านล่างเพื่อสร้างหรือแก้ไข', ja: ' ブランドサイト。下から作成・編集へ進めます。', ko: ' 브랜드 사이트. 아래에서 만들거나 편집하세요.',
  },
  'auth.goAdmin': {
    'zh-TW': '進入我的網站', 'zh-CN': '进入我的网站', en: 'Go to my websites', id: 'Ke situs saya', vi: 'Vào website của tôi', th: 'ไปที่เว็บของฉัน', ja: 'マイサイトへ', ko: '내 웹사이트로',
  },
  'auth.logout': {
    'zh-TW': '登出', 'zh-CN': '登出', en: 'Sign out', id: 'Keluar', vi: 'Đăng xuất', th: 'ออก', ja: 'ログアウト', ko: '로그아웃',
  },
  'auth.oauthLabel': {
    'zh-TW': '快速登入', 'zh-CN': '快速登录', en: 'Quick sign-in', id: 'Masuk cepat', vi: 'Đăng nhập nhanh', th: 'เข้าสู่ระบบเร็ว', ja: 'かんたんログイン', ko: '간편 로그인',
  },
  'auth.oauthGoogle': {
    'zh-TW': '以 Google 繼續', 'zh-CN': '用 Google 继续', en: 'Continue with Google', id: 'Lanjut dengan Google', vi: 'Tiếp tục với Google', th: 'ต่อด้วย Google', ja: 'Google で続行', ko: 'Google로 계속',
  },
  'auth.oauthLine': {
    'zh-TW': '以 LINE 繼續', 'zh-CN': '用 LINE 继续', en: 'Continue with LINE', id: 'Lanjut dengan LINE', vi: 'Tiếp tục với LINE', th: 'ต่อด้วย LINE', ja: 'LINE で続行', ko: 'LINE으로 계속',
  },
  'auth.oauthFacebook': {
    'zh-TW': '以 Facebook 繼續', 'zh-CN': '用 Facebook 继续', en: 'Continue with Facebook', id: 'Lanjut dengan Facebook', vi: 'Tiếp tục với Facebook', th: 'ต่อด้วย Facebook', ja: 'Facebook で続行', ko: 'Facebook으로 계속',
  },
  'auth.oauthHint': {
    'zh-TW': '示範環境可直接點選體驗；正式上線後改接各平台官方登入。',
    'zh-CN': '示范环境可直接点选体验；正式上线后改接各平台官方登录。',
    en: 'Demo mode — tap to try. Production will use official provider sign-in.',
    id: 'Mode demo — ketuk untuk mencoba. Produksi memakai login resmi.',
    vi: 'Chế độ demo — bấm để thử. Production sẽ dùng đăng nhập chính thức.',
    th: 'โหมดเดโม — แตะเพื่อลอง โปรดักชันจะใช้ล็อกอินทางการ',
    ja: 'デモではそのまま体験できます。本番では各社の公式ログインに接続します。',
    ko: '데모에서는 바로 체험할 수 있습니다. 운영 환경에서는 공식 로그인을 연결합니다.',
  },
  'auth.register': {
    'zh-TW': '註冊', 'zh-CN': '注册', en: 'Register', id: 'Daftar', vi: 'Đăng ký', th: 'สมัคร', ja: '登録', ko: '가입',
  },
  'auth.login': {
    'zh-TW': '登入', 'zh-CN': '登录', en: 'Sign in', id: 'Masuk', vi: 'Đăng nhập', th: 'เข้าสู่ระบบ', ja: 'ログイン', ko: '로그인',
  },
  'auth.displayName': {
    'zh-TW': '顯示名稱', 'zh-CN': '显示名称', en: 'Display name', id: 'Nama tampilan', vi: 'Tên hiển thị', th: 'ชื่อที่แสดง', ja: '表示名', ko: '표시 이름',
  },
  'auth.displayNamePh': {
    'zh-TW': '你的名字', 'zh-CN': '你的名字', en: 'Your name', id: 'Nama Anda', vi: 'Tên của bạn', th: 'ชื่อของคุณ', ja: 'お名前', ko: '이름',
  },
  'auth.password': {
    'zh-TW': '密碼', 'zh-CN': '密码', en: 'Password', id: 'Kata sandi', vi: 'Mật khẩu', th: 'รหัสผ่าน', ja: 'パスワード', ko: '비밀번호',
  },
  'auth.createAccount': {
    'zh-TW': '建立帳號', 'zh-CN': '建立账号', en: 'Create account', id: 'Buat akun', vi: 'Tạo tài khoản', th: 'สร้างบัญชี', ja: 'アカウント作成', ko: '계정 만들기',
  },
  'auth.sendCode': {
    'zh-TW': '寄送驗證碼', 'zh-CN': '发送验证码', en: 'Send code', id: 'Kirim kode', vi: 'Gửi mã', th: 'ส่งรหัส', ja: 'コード送信', ko: '인증코드 전송',
  },
  'auth.resendIn': {
    'zh-TW': '{s} 秒後可重寄', 'zh-CN': '{s} 秒后可重发', en: 'Resend in {s}s', id: 'Kirim ulang {s}d', vi: 'Gửi lại sau {s}s', th: 'ส่งอีกใน {s}วิ', ja: '{s}秒後に再送', ko: '{s}초 후 재전송',
  },
  'auth.verifyCode': {
    'zh-TW': 'Email 驗證碼', 'zh-CN': '邮箱验证码', en: 'Email verification code', id: 'Kode verifikasi email', vi: 'Mã xác minh email', th: 'รหัสยืนยันอีเมล', ja: 'メール認証コード', ko: '이메일 인증코드',
  },
  'auth.codeSent': {
    'zh-TW': '驗證碼已寄出，請查收郵件。', 'zh-CN': '验证码已发送，请查收邮件。', en: 'Verification code sent. Check your email.', id: 'Kode dikirim. Cek email Anda.', vi: 'Đã gửi mã. Kiểm tra email.', th: 'ส่งรหัสแล้ว ตรวจสอบอีเมล', ja: '認証コードを送信しました。メールをご確認ください。', ko: '인증코드를 보냈습니다. 이메일을 확인하세요.',
  },
  'auth.err.email': {
    'zh-TW': '請輸入有效的 Email。', 'zh-CN': '请输入有效的邮箱。', en: 'Enter a valid email.', id: 'Masukkan email valid.', vi: 'Nhập email hợp lệ.', th: 'กรอกอีเมลให้ถูกต้อง', ja: '有効なメールを入力してください。', ko: '올바른 이메일을 입력하세요.',
  },
  'auth.err.code': {
    'zh-TW': '請先完成 Email 驗證碼。', 'zh-CN': '请先完成邮箱验证码。', en: 'Enter the email verification code first.', id: 'Masukkan kode verifikasi email dulu.', vi: 'Nhập mã xác minh email trước.', th: 'กรอกรหัสยืนยันอีเมลก่อน', ja: '先にメール認証コードを入力してください。', ko: '먼저 이메일 인증코드를 입력하세요.',
  },
  'auth.err.rate': {
    'zh-TW': '寄送太頻繁，請稍後再試。', 'zh-CN': '发送太频繁，请稍后再试。', en: 'Too many sends. Try again shortly.', id: 'Terlalu sering. Coba lagi sebentar.', vi: 'Gửi quá nhiều. Thử lại sau.', th: 'ส่งถี่เกินไป ลองใหม่ภายหลัง', ja: '送信が多すぎます。しばらくしてから再試行。', ko: '전송이 너무 잦습니다. 잠시 후 다시 시도하세요.',
  },
  'auth.err.registered': {
    'zh-TW': '此 Email 已註冊，請直接登入。', 'zh-CN': '此邮箱已注册，请直接登录。', en: 'This email is already registered. Sign in instead.', id: 'Email sudah terdaftar. Silakan masuk.', vi: 'Email đã đăng ký. Hãy đăng nhập.', th: 'อีเมลนี้ลงทะเบียนแล้ว กรุณาเข้าสู่ระบบ', ja: 'このメールは登録済みです。ログインしてください。', ko: '이미 가입된 이메일입니다. 로그인하세요.',
  },
  'auth.err.password': {
    'zh-TW': '密碼至少 6 個字元。', 'zh-CN': '密码至少 6 个字符。', en: 'Password must be at least 6 characters.', id: 'Kata sandi minimal 6 karakter.', vi: 'Mật khẩu tối thiểu 6 ký tự.', th: 'รหัสผ่านอย่างน้อย 6 ตัวอักษ', ja: 'パスワードは6文字以上。', ko: '비밀번호는 6자 이상이어야 합니다.',
  },
  'auth.err.send': {
    'zh-TW': '驗證碼寄送失敗，請稍後再試。', 'zh-CN': '验证码发送失败，请稍后再试。', en: 'Failed to send verification code. Try again later.', id: 'Gagal kirim kode. Coba lagi nanti.', vi: 'Gửi mã thất bại. Thử lại sau.', th: 'ส่งรหัสไม่สำเร็จ ลองใหม่ภายหลัง', ja: '認証コードの送信に失敗しました。', ko: '인증코드 전송에 실패했습니다.',
  },
  'footer.privacy': {
    'zh-TW': '隱私權政策', 'zh-CN': '隐私权政策', en: 'Privacy Policy', id: 'Kebijakan Privasi', vi: 'Chính sách bảo mật', th: 'นโยบายความเป็นส่วนตัว', ja: 'プライバシーポリシー', ko: '개인정보 처리방침',
  },
  'footer.terms': {
    'zh-TW': '服務條款', 'zh-CN': '服务条款', en: 'Terms of Service', id: 'Ketentuan Layanan', vi: 'Điều khoản dịch vụ', th: 'เงื่อนไขการใช้บริการ', ja: '利用規約', ko: '이용약관',
  },
  'footer.deletion': {
    'zh-TW': '會員刪除機制', 'zh-CN': '会员删除机制', en: 'Account Deletion', id: 'Penghapusan Akun', vi: 'Xóa tài khoản', th: 'การลบบัญชี', ja: 'アカウント削除', ko: '회원 삭제',
  },
  'footer.legal': {
    'zh-TW': '法律資訊', 'zh-CN': '法律信息', en: 'Legal', id: 'Legal', vi: 'Pháp lý', th: 'กฎหมาย', ja: '法務', ko: '법률',
  },
  'footer.rights': {
    'zh-TW': '保留所有權利。', 'zh-CN': '保留所有权利。', en: 'All rights reserved.', id: 'Hak cipta dilindungi.', vi: 'Bảo lưu mọi quyền.', th: 'สงวนลิขสิทธิ์', ja: 'All rights reserved.', ko: '모든 권리 보유.',
  },
  'shell.home': {
    'zh-TW': '首頁', 'zh-CN': '首页', en: 'Home', id: 'Beranda', vi: 'Trang chủ', th: 'หน้าแรก', ja: 'ホーム', ko: '홈',
  },
  'shell.lang': {
    'zh-TW': '語系', 'zh-CN': '语系', en: 'Language', id: 'Bahasa', vi: 'Ngôn ngữ', th: 'ภาษา', ja: '言語', ko: '언어',
  },
  'i18n.missingDemo': { 'zh-TW': '這句只有繁中' },

  'nav.home': {
    'zh-TW': '首頁', 'zh-CN': '首页', en: 'Home', id: 'Beranda', vi: 'Trang chủ', th: 'หน้าแรก', ja: 'ホーム', ko: '홈',
  },
  'nav.features': {
    'zh-TW': '功能', 'zh-CN': '功能', en: 'Features', id: 'Fitur', vi: 'Tính năng', th: 'ฟีเจอร์', ja: '機能', ko: '기능',
  },
  'nav.docs': {
    'zh-TW': '文件', 'zh-CN': '文档', en: 'Docs', id: 'Dokumen', vi: 'Tài liệu', th: 'เอกสาร', ja: 'ドキュメント', ko: '문서',
  },
  'nav.contact': {
    'zh-TW': '聯絡', 'zh-CN': '联系', en: 'Contact', id: 'Kontak', vi: 'Liên hệ', th: 'ติดต่อ', ja: 'お問い合わせ', ko: '문의',
  },
  'nav.examples': {
    'zh-TW': '範例', 'zh-CN': '范例', en: 'Examples', id: 'Contoh', vi: 'Ví dụ', th: 'ตัวอย่าง', ja: '事例', ko: '예시',
  },
  'examples.pageTitle': {
    'zh-TW': '主題範例', 'zh-CN': '主题范例', en: 'Theme examples', id: 'Contoh tema', vi: 'Ví dụ theme', th: 'ตัวอย่างธีม', ja: 'テーマ事例', ko: '테마 예시',
  },
  'examples.pageSub': {
    'zh-TW': '瀏覽實際站台主題樣式。',
    'zh-CN': '浏览实际站点主题样式。',
    en: 'Browse live theme styles.',
    id: 'Jelajahi gaya tema live.',
    vi: 'Xem các kiểu theme thực tế.',
    th: 'ชมสไตล์ธีมจริง',
    ja: '実サイトのテーマスタイルを閲覧。',
    ko: '실제 사이트 테마 스타일을 둘러보세요.',
  },
  'examples.filterAll': {
    'zh-TW': '全部', 'zh-CN': '全部', en: 'All', id: 'Semua', vi: 'Tất cả', th: 'ทั้งหมด', ja: 'すべて', ko: '전체',
  },
  'examples.cat.marketing': {
    'zh-TW': '行銷落地頁', 'zh-CN': '营销落地页', en: 'Marketing', id: 'Marketing', vi: 'Marketing', th: 'การตลาด', ja: 'マーケ', ko: '마케팅',
  },
  'examples.cat.corporate': {
    'zh-TW': '企業形象', 'zh-CN': '企业形象', en: 'Corporate', id: 'Korporat', vi: 'Doanh nghiệp', th: 'องค์กร', ja: 'コーポレート', ko: '기업',
  },
  'examples.cat.shopping': {
    'zh-TW': '購物商城', 'zh-CN': '购物商城', en: 'Shopping', id: 'Belanja', vi: 'Mua sắm', th: 'ช้อปปิ้ง', ja: 'ショッピング', ko: '쇼핑',
  },
  'examples.cat.vertical': {
    'zh-TW': '垂直平台', 'zh-CN': '垂直平台', en: 'Vertical', id: 'Vertikal', vi: 'Dọc', th: 'แนวตั้ง', ja: 'バーティカル', ko: '버티컬',
  },
  'examples.front': {
    'zh-TW': '前台', 'zh-CN': '前台', en: 'Storefront', id: 'Depan', vi: 'Front', th: 'หน้าเว็บ', ja: 'フロント', ko: '프론트',
  },
  'examples.admin': {
    'zh-TW': '後台', 'zh-CN': '后台', en: 'Admin', id: 'Admin', vi: 'Admin', th: 'แอดมิน', ja: '管理画面', ko: '관리자',
  },
  'examples.account': {
    'zh-TW': '帳號', 'zh-CN': '账号', en: 'Account', id: 'Akun', vi: 'Tài khoản', th: 'บัญชี', ja: 'アカウント', ko: '계정',
  },
  'examples.password': {
    'zh-TW': '密碼', 'zh-CN': '密码', en: 'Password', id: 'Kata sandi', vi: 'Mật khẩu', th: 'รหัสผ่าน', ja: 'パスワード', ko: '비밀번호',
  },
  'examples.copy': {
    'zh-TW': '複製', 'zh-CN': '复制', en: 'Copy', id: 'Salin', vi: 'Sao chép', th: 'คัดลอก', ja: 'コピー', ko: '복사',
  },
  'examples.openFront': {
    'zh-TW': '開啟前台', 'zh-CN': '打开前台', en: 'Open site', id: 'Buka situs', vi: 'Mở site', th: 'เปิดเว็บ', ja: 'サイトを開く', ko: '사이트 열기',
  },
  'examples.openAdmin': {
    'zh-TW': '開啟後台', 'zh-CN': '打开后台', en: 'Open admin', id: 'Buka admin', vi: 'Mở admin', th: 'เปิดแอดมิน', ja: '管理画面を開く', ko: '관리자 열기',
  },
  'examples.openPrompt': {
    'zh-TW': 'Prompt', 'zh-CN': 'Prompt', en: 'Prompt', id: 'Prompt', vi: 'Prompt', th: 'Prompt', ja: 'Prompt', ko: 'Prompt',
  },
  'examples.createMySite': {
    'zh-TW': '用此 Prompt 建立我的網站',
    'zh-CN': '用此 Prompt 建立我的网站',
    en: 'Create my site from this prompt',
    id: 'Buat situs dari prompt ini',
    vi: 'Tạo site từ prompt này',
    th: 'สร้างเว็บจาก Prompt นี้',
    ja: 'この Prompt でサイトを作成',
    ko: '이 Prompt로 사이트 만들기',
  },
  'examples.createMySiteHint': {
    'zh-TW': '建立私人站（不進 Examples）：CMS／商品／媒體／聯絡／SEO／RWD／PWA，可於會員 Console 完成。',
    'zh-CN': '建立私人站（不进 Examples）：CMS／商品／媒体／联络／SEO／RWD／PWA，可于会员 Console 完成。',
    en: 'Creates a private site (not in Examples): CMS, catalog, media, contact, SEO, RWD, PWA — finish in member Console.',
    id: 'Membuat situs privat (bukan Examples): CMS, katalog, media, kontak, SEO, RWD, PWA — lanjut di Console anggota.',
    vi: 'Tạo site riêng (không vào Examples): CMS, catalog, media, liên hệ, SEO, RWD, PWA — hoàn tất trên Console thành viên.',
    th: 'สร้างเว็บส่วนตัว (ไม่เข้า Examples): CMS, สินค้า, สื่อ, ติดต่อ, SEO, RWD, PWA — ทำต่อที่ Console สมาชิก',
    ja: 'プライベートサイトを作成（Examples 非掲載）。CMS／商品／メディア／連絡／SEO／RWD／PWA。会員 Console で完了。',
    ko: '비공개 사이트 생성(Examples 미포함): CMS/상품/미디어/연락처/SEO/RWD/PWA — 회원 Console에서 완료.',
  },
  'examples.createMySiteNeedValidate': {
    'zh-TW': '請先通過 Validate & project',
    'zh-CN': '请先通过 Validate & project',
    en: 'Validate & project must pass first',
    id: 'Validate & project harus lulus dulu',
    vi: 'Cần Validate & project thành công trước',
    th: 'ต้องผ่าน Validate & project ก่อน',
    ja: '先に Validate & project を通してください',
    ko: '먼저 Validate & project를 통과하세요',
  },
  'examples.createMySiteNeedTheme': {
    'zh-TW': '請從 Examples 開啟 Prompt Studio 才能建立私人站',
    'zh-CN': '请从 Examples 打开 Prompt Studio 才能建立私人站',
    en: 'Open from Examples to create a private site',
    id: 'Buka dari Examples untuk membuat situs privat',
    vi: 'Mở từ Examples để tạo site riêng',
    th: 'เปิดจาก Examples เพื่อสร้างเว็บส่วนตัว',
    ja: 'Examples から開くとプライベートサイトを作成できます',
    ko: 'Examples에서 열어야 비공개 사이트를 만들 수 있습니다',
  },
  'examples.createMySiteReady': {
    'zh-TW': '前往會員 Console 的 Prompt 精靈',
    'zh-CN': '前往会员 Console 的 Prompt 向导',
    en: 'Hand off to member console Prompt wizard',
    id: 'Lanjut ke wizard Prompt di Console anggota',
    vi: 'Chuyển sang Prompt wizard trên Console thành viên',
    th: 'ส่งต่อไปยัง Prompt wizard ใน Console สมาชิก',
    ja: '会員 Console の Prompt ウィザードへ引き継ぎ',
    ko: '회원 Console Prompt 마법사로 전달',
  },
  'studio.title': {
    'zh-TW': 'Prompt Studio', 'zh-CN': 'Prompt Studio', en: 'Prompt Studio', id: 'Prompt Studio', vi: 'Prompt Studio', th: 'Prompt Studio', ja: 'Prompt Studio', ko: 'Prompt Studio',
  },
  'studio.subtitle': {
    'zh-TW': '網站需求規格（Markdown ↔ Tool 同步）',
    'zh-CN': '网站需求规格（Markdown ↔ Tool 同步）',
    en: 'Website specification (Markdown ↔ Tool sync)',
    id: 'Penulisan skill mybo.site.v1 (validate + project)',
    vi: 'Soạn skill mybo.site.v1 (validate + project)',
    th: 'เขียน skill mybo.site.v1 (validate + project)',
    ja: 'mybo.site.v1 skill 作成（検証＋投影）',
    ko: 'mybo.site.v1 skill 작성(검증＋투영)',
  },
  'studio.close': {
    'zh-TW': '關閉', 'zh-CN': '关闭', en: 'Close', id: 'Tutup', vi: 'Đóng', th: 'ปิด', ja: '閉じる', ko: '닫기',
  },
  'studio.validate': {
    'zh-TW': '驗證並投影', 'zh-CN': '验证并投影', en: 'Validate & project', id: 'Validate & project', vi: 'Validate & project', th: 'Validate & project', ja: '検証して投影', ko: '검증 및 투영',
  },
  'studio.overallPass': {
    'zh-TW': '整體驗證通過',
    'zh-CN': '整体验证通过',
    en: 'Overall validation passed',
    id: 'Validasi keseluruhan berhasil',
    vi: 'Xác thực tổng thể đã đạt',
    th: 'การตรวจสอบโดยรวมผ่าน',
    ja: '全体検証に合格しました',
    ko: '전체 검증 통과',
  },
  'studio.overallFail': {
    'zh-TW': '整體驗證未通過：{count} 個問題',
    'zh-CN': '整体验证未通过：{count} 个问题',
    en: 'Overall validation failed: {count} issue(s)',
    id: 'Validasi keseluruhan gagal: {count} masalah',
    vi: 'Xác thực tổng thể chưa đạt: {count} vấn đề',
    th: 'การตรวจสอบโดยรวมไม่ผ่าน: {count} ปัญหา',
    ja: '全体検証に未合格：{count} 件の問題',
    ko: '전체 검증 실패: 문제 {count}개',
  },
  'studio.projecting': {
    'zh-TW': '投影中…', 'zh-CN': '投影中…', en: 'Projecting…', id: 'Memproyeksikan…', vi: 'Đang chiếu…', th: 'กำลังโปรเจกต์…', ja: '投影中…', ko: '투영 중…',
  },
  'studio.previewDeferred': {
    'zh-TW': 'Preview iframe 暫緩，待套件預覽主機就緒後再接。',
    'zh-CN': 'Preview iframe 暂缓，待套件预览主机就绪后再接。',
    en: 'Preview iframe is deferred until package preview hosting is wired.',
    id: 'Preview iframe ditunda sampai hosting preview paket siap.',
    vi: 'Preview iframe tạm hoãn đến khi hosting preview package sẵn sàng.',
    th: 'เลื่อน Preview iframe ไว้ก่อน จนกว่า hosting ตัวอย่างแพ็กเกจจะพร้อม',
    ja: 'Preview iframe はパッケージプレビュー環境が整うまで保留です。',
    ko: '패키지 미리보기 호스팅이 준비될 때까지 Preview iframe은 보류됩니다.',
  },
  'studio.previewNote': {
    'zh-TW': '即時規格預覽；色彩與區塊會跟隨目前的 Markdown。',
    'zh-CN': '实时规格预览；颜色与区块会跟随当前 Markdown。',
    en: 'Live specification preview. Colors and sections follow the current Markdown.',
    id: 'Pratinjau spesifikasi langsung. Warna dan bagian mengikuti Markdown saat ini.',
    vi: 'Bản xem trước đặc tả trực tiếp. Màu sắc và khu vực theo Markdown hiện tại.',
    th: 'ตัวอย่างข้อกำหนดแบบสด สีและส่วนต่าง ๆ จะเปลี่ยนตาม Markdown ปัจจุบัน',
    ja: '仕様のライブプレビューです。色とセクションは現在の Markdown に同期します。',
    ko: '실시간 사양 미리보기입니다. 색상과 섹션은 현재 Markdown을 따릅니다.',
  },
  'studio.livePreviewTitle': {
    'zh-TW': '即時網站預覽',
    'zh-CN': '实时网站预览',
    en: 'Live website preview',
    id: 'Pratinjau situs langsung',
    vi: 'Xem trước website trực tiếp',
    th: 'ตัวอย่างเว็บไซต์แบบสด',
    ja: 'ウェブサイトのライブプレビュー',
    ko: '실시간 웹사이트 미리보기',
  },
  'studio.previewCta': {
    'zh-TW': '立即開始', 'zh-CN': '立即开始', en: 'Get started', id: 'Mulai', vi: 'Bắt đầu', th: 'เริ่มต้น', ja: '始める', ko: '시작하기',
  },
  'studio.previewLearnMore': {
    'zh-TW': '了解更多', 'zh-CN': '了解更多', en: 'Learn more', id: 'Pelajari lebih lanjut', vi: 'Tìm hiểu thêm', th: 'เรียนรู้เพิ่มเติม', ja: '詳しく見る', ko: '자세히 보기',
  },
  'studio.previewSectionDescription': {
    'zh-TW': '{brand} 的「{title}」內容區塊',
    'zh-CN': '{brand} 的“{title}”内容区块',
    en: '{brand} — {title} section',
    id: 'Bagian {title} dari {brand}',
    vi: 'Khu vực {title} của {brand}',
    th: 'ส่วน {title} ของ {brand}',
    ja: '{brand} の「{title}」セクション',
    ko: '{brand}의 {title} 섹션',
  },
  'studio.visualPickerHint': {
    'zh-TW': '請依縮圖選擇；選取後會立即更新網站規格。',
    'zh-CN': '请按缩略图选择；选择后会立即更新网站规格。',
    en: 'Choose by preview; the selection updates the specification immediately.',
    id: 'Pilih berdasarkan pratinjau; pilihan langsung memperbarui spesifikasi.',
    vi: 'Chọn theo hình xem trước; lựa chọn sẽ cập nhật đặc tả ngay.',
    th: 'เลือกจากภาพตัวอย่าง แล้วข้อกำหนดจะอัปเดตทันที',
    ja: 'プレビューから選択すると、仕様がすぐに更新されます。',
    ko: '미리보기로 선택하면 사양이 즉시 업데이트됩니다.',
  },
  'studio.openPreview': {
    'zh-TW': '開啟來源 Example',
    'zh-CN': '打开来源 Example',
    en: 'Open source Example',
    id: 'Buka Example sumber',
    vi: 'Mở Example nguồn',
    th: 'เปิด Example ต้นทาง',
    ja: '元の Example を開く',
    ko: '원본 Example 열기',
  },
  'studio.modeMarkdown': {
    'zh-TW': 'Markdown', 'zh-CN': 'Markdown', en: 'Markdown', id: 'Markdown', vi: 'Markdown', th: 'Markdown', ja: 'Markdown', ko: 'Markdown',
  },
  'studio.modeTool': {
    'zh-TW': 'Tool', 'zh-CN': 'Tool', en: 'Tool', id: 'Tool', vi: 'Tool', th: 'Tool', ja: 'Tool', ko: 'Tool',
  },
  'studio.modePreview': {
    'zh-TW': 'Preview', 'zh-CN': 'Preview', en: 'Preview', id: 'Preview', vi: 'Preview', th: 'Preview', ja: 'Preview', ko: 'Preview',
  },
  'studio.modeAria': {
    'zh-TW': 'Prompt Studio 模式', 'zh-CN': 'Prompt Studio 模式', en: 'Prompt Studio mode', id: 'Mode Prompt Studio', vi: 'Chế độ Prompt Studio', th: 'โหมด Prompt Studio', ja: 'Prompt Studio モード', ko: 'Prompt Studio 모드',
  },
  'studio.toolPanelsAria': {
    'zh-TW': 'Tool 面板', 'zh-CN': 'Tool 面板', en: 'Tool panels', id: 'Panel Tool', vi: 'Các panel Tool', th: 'แผง Tool', ja: 'Tool パネル', ko: 'Tool 패널',
  },
  'studio.panel.Site': {
    'zh-TW': '站台', 'zh-CN': '站点', en: 'Site', id: 'Site', vi: 'Site', th: 'Site', ja: 'サイト', ko: '사이트',
  },
  'studio.panel.Shell': {
    'zh-TW': '外殼', 'zh-CN': '外壳', en: 'Shell', id: 'Shell', vi: 'Shell', th: 'Shell', ja: 'シェル', ko: '셸',
  },
  'studio.panel.Page': {
    'zh-TW': '頁面', 'zh-CN': '页面', en: 'Page', id: 'Page', vi: 'Page', th: 'Page', ja: 'ページ', ko: '페이지',
  },
  'studio.panel.Section': {
    'zh-TW': '區塊', 'zh-CN': '区块', en: 'Section', id: 'Section', vi: 'Section', th: 'Section', ja: 'セクション', ko: '섹션',
  },
  'studio.panel.Design': {
    'zh-TW': '設計', 'zh-CN': '设计', en: 'Design', id: 'Design', vi: 'Design', th: 'Design', ja: 'デザイン', ko: '디자인',
  },
  'studio.panel.RWD': {
    'zh-TW': 'RWD', 'zh-CN': 'RWD', en: 'RWD', id: 'RWD', vi: 'RWD', th: 'RWD', ja: 'RWD', ko: 'RWD',
  },
  'studio.panel.Media': {
    'zh-TW': '媒體', 'zh-CN': '媒体', en: 'Media', id: 'Media', vi: 'Media', th: 'Media', ja: 'メディア', ko: '미디어',
  },
  'studio.panel.Content': {
    'zh-TW': '內容', 'zh-CN': '内容', en: 'Content', id: 'Content', vi: 'Content', th: 'Content', ja: 'コンテンツ', ko: '콘텐츠',
  },
  'studio.panel.Capabilities': {
    'zh-TW': '能力', 'zh-CN': '能力', en: 'Capabilities', id: 'Capabilities', vi: 'Capabilities', th: 'Capabilities', ja: '機能', ko: '기능',
  },
  'studio.panel.SEO': {
    'zh-TW': 'SEO', 'zh-CN': 'SEO', en: 'SEO', id: 'SEO', vi: 'SEO', th: 'SEO', ja: 'SEO', ko: 'SEO',
  },
  'studio.panelAria': {
    'zh-TW': '{panel} 面板', 'zh-CN': '{panel} 面板', en: '{panel} panel', id: 'Panel {panel}', vi: 'Panel {panel}', th: 'แผง {panel}', ja: '{panel} パネル', ko: '{panel} 패널',
  },
  'studio.empty.site': {
    'zh-TW': '請先執行「驗證並投影」以載入站台欄位。',
    'zh-CN': '请先执行「验证并投影」以载入站点字段。',
    en: 'Run Validate & project to load projected Site fields.',
    id: 'Jalankan Validate & project untuk memuat field Site.',
    vi: 'Chạy Validate & project để tải trường Site.',
    th: 'รัน Validate & project เพื่อโหลดฟิลด์ Site',
    ja: 'Validate & project を実行してサイト欄を読み込んでください。',
    ko: 'Validate & project를 실행해 사이트 필드를 불러오세요.',
  },
  'studio.empty.shell': {
    'zh-TW': '請先執行「驗證並投影」以載入 Shell 欄位，或在 Architecture 投影後撰寫 shell 區塊。',
    'zh-CN': '请先执行「验证并投影」以载入 Shell 字段，或在 Architecture 投影后撰写 shell 区块。',
    en: 'Run Validate & project to load Shell fields, or write a shell block after Architecture is projected.',
    id: 'Jalankan Validate & project untuk memuat field Shell, atau tulis blok shell setelah Architecture diproyeksikan.',
    vi: 'Chạy Validate & project để tải trường Shell, hoặc viết khối shell sau khi Architecture đã chiếu.',
    th: 'รัน Validate & project เพื่อโหลดฟิลด์ Shell หรือเขียนบล็อก shell หลัง Architecture ถูกโปรเจกต์',
    ja: 'Validate & project で Shell 欄を読み込むか、Architecture 投影後に shell ブロックを書いてください。',
    ko: 'Validate & project로 Shell 필드를 불러오거나 Architecture 투영 후 shell 블록을 작성하세요.',
  },
  'studio.empty.design': {
    'zh-TW': '請先執行「驗證並投影」以載入 Design 欄位，或在標題存在後於下方撰寫 Design System。',
    'zh-CN': '请先执行「验证并投影」以载入 Design 字段，或在标题存在后于下方撰写 Design System。',
    en: 'Run Validate & project to load Design fields, or author Design System rows below once the heading exists.',
    id: 'Jalankan Validate & project untuk memuat field Design, atau tulis baris Design System di bawah setelah heading ada.',
    vi: 'Chạy Validate & project để tải trường Design, hoặc soạn Design System bên dưới khi đã có heading.',
    th: 'รัน Validate & project เพื่อโหลดฟิลด์ Design หรือเขียน Design System ด้านล่างเมื่อมีหัวข้อแล้ว',
    ja: 'Validate & project で Design 欄を読み込むか、見出しがある状態で下の Design System を書いてください。',
    ko: 'Validate & project로 Design 필드를 불러오거나 제목이 있으면 아래에서 Design System을 작성하세요.',
  },
  'studio.empty.section': {
    'zh-TW': '尚無投影的區塊。請在宣告 <code># Sections</code> 後執行「驗證並投影」。',
    'zh-CN': '尚无投影的区块。请在声明 <code># Sections</code> 后执行「验证并投影」。',
    en: 'No sections projected yet. Run Validate & project after declaring <code># Sections</code>.',
    id: 'Belum ada section terproyeksi. Jalankan Validate & project setelah mendeklarasikan <code># Sections</code>.',
    vi: 'Chưa có section được chiếu. Chạy Validate & project sau khi khai báo <code># Sections</code>.',
    th: 'ยังไม่มี section ที่โปรเจกต์ รัน Validate & project หลังประกาศ <code># Sections</code>',
    ja: 'まだセクションが投影されていません。<code># Sections</code> を宣言してから Validate & project を実行してください。',
    ko: '투영된 섹션이 없습니다. <code># Sections</code>를 선언한 뒤 Validate & project를 실행하세요.',
  },
  'studio.empty.seo': {
    'zh-TW': '請在站台面板設定 locale（或執行「驗證並投影」）。仍可於下方撰寫 title／description。',
    'zh-CN': '请在站点面板设置 locale（或执行「验证并投影」）。仍可于下方撰写 title／description。',
    en: 'Set locale in the Site panel (or run Validate & project). You can still author title／description below.',
    id: 'Setel locale di panel Site (atau jalankan Validate & project). Anda masih bisa menulis title／description di bawah.',
    vi: 'Đặt locale ở panel Site (hoặc chạy Validate & project). Vẫn có thể soạn title／description bên dưới.',
    th: 'ตั้ง locale ในแผง Site (หรือรัน Validate & project) ยังเขียน title／description ด้านล่างได้',
    ja: 'Site パネルで locale を設定するか Validate & project を実行してください。下で title／description は書けます。',
    ko: 'Site 패널에서 locale을 설정하거나 Validate & project를 실행하세요. 아래에서 title／description은 계속 작성할 수 있습니다.',
  },
  'studio.hint.required': {
    'zh-TW': '必填', 'zh-CN': '必填', en: 'required', id: 'wajib', vi: 'bắt buộc', th: 'จำเป็น', ja: '必須', ko: '필수',
  },
  'studio.hint.unsupported': {
    'zh-TW': '不支援', 'zh-CN': '不支持', en: 'unsupported', id: 'tidak didukung', vi: 'không hỗ trợ', th: 'ไม่รองรับ', ja: '未対応', ko: '미지원',
  },
  'studio.hint.unknown': {
    'zh-TW': '未知', 'zh-CN': '未知', en: 'unknown', id: 'tidak dikenal', vi: 'không rõ', th: 'ไม่รู้จัก', ja: '不明', ko: '알 수 없음',
  },
  'studio.hint.skillOnly': {
    'zh-TW': '僅 mybo.site.v1', 'zh-CN': '仅 mybo.site.v1', en: 'mybo.site.v1 only', id: 'hanya mybo.site.v1', vi: 'chỉ mybo.site.v1', th: 'เฉพาะ mybo.site.v1', ja: 'mybo.site.v1 のみ', ko: 'mybo.site.v1만',
  },
  'studio.hint.specializeRequired': {
    'zh-TW': 'specialize 必填', 'zh-CN': 'specialize 必填', en: 'required for specialize', id: 'wajib untuk specialize', vi: 'bắt buộc khi specialize', th: 'จำเป็นสำหรับ specialize', ja: 'specialize では必須', ko: 'specialize에 필수',
  },
  'studio.site.skill': {
    'zh-TW': 'Skill', 'zh-CN': 'Skill', en: 'Skill', id: 'Skill', vi: 'Skill', th: 'Skill', ja: 'Skill', ko: 'Skill',
  },
  'studio.site.locale': {
    'zh-TW': '語系', 'zh-CN': '语系', en: 'Locale', id: 'Locale', vi: 'Locale', th: 'Locale', ja: 'ロケール', ko: '로케일',
  },
  'studio.site.brandName': {
    'zh-TW': '品牌名稱', 'zh-CN': '品牌名称', en: 'Brand name', id: 'Nama merek', vi: 'Tên thương hiệu', th: 'ชื่อแบรนด์', ja: 'ブランド名', ko: '브랜드 이름',
  },
  'studio.site.generationMode': {
    'zh-TW': '產生模式', 'zh-CN': '生成模式', en: 'Generation mode', id: 'Mode generasi', vi: 'Chế độ tạo', th: 'โหมดสร้าง', ja: '生成モード', ko: '생성 모드',
  },
  'studio.site.archetype': {
    'zh-TW': '原型', 'zh-CN': '原型', en: 'Archetype', id: 'Archetype', vi: 'Archetype', th: 'Archetype', ja: 'アーキタイプ', ko: '아키타입',
  },
  'studio.site.sourceThemeKey': {
    'zh-TW': '來源 themeKey', 'zh-CN': '来源 themeKey', en: 'sourceThemeKey', id: 'sourceThemeKey', vi: 'sourceThemeKey', th: 'sourceThemeKey', ja: 'sourceThemeKey', ko: 'sourceThemeKey',
  },
  'studio.site.audience': {
    'zh-TW': '受眾', 'zh-CN': '受众', en: 'Audience', id: 'Audiens', vi: 'Đối tượng', th: 'ผู้ชม', ja: 'オーディエンス', ko: '대상',
  },
  'studio.site.goal': {
    'zh-TW': '目標', 'zh-CN': '目标', en: 'Goal', id: 'Tujuan', vi: 'Mục tiêu', th: 'เป้าหมาย', ja: '目標', ko: '목표',
  },
  'studio.site.refuseIfIncomplete': {
    'zh-TW': '未完成則拒絕', 'zh-CN': '未完成则拒绝', en: 'refuseIfIncomplete', id: 'refuseIfIncomplete', vi: 'refuseIfIncomplete', th: 'refuseIfIncomplete', ja: 'refuseIfIncomplete', ko: 'refuseIfIncomplete',
  },
  'studio.site.topology': {
    'zh-TW': '拓樸', 'zh-CN': '拓扑', en: 'Topology', id: 'Topology', vi: 'Topology', th: 'Topology', ja: 'トポロジ', ko: '토폴로지',
  },
  'studio.site.intent': {
    'zh-TW': '意圖', 'zh-CN': '意图', en: 'Intent', id: 'Intent', vi: 'Intent', th: 'Intent', ja: 'Intent', ko: 'Intent',
  },
  'studio.site.intentPlaceholder': {
    'zh-TW': '用至少 40 字描述網站目的、受眾與商品／服務。',
    'zh-CN': '用至少 40 字描述网站目的、受众与商品／服务。',
    en: 'Describe the site purpose, audience, and offer in at least 40 characters.',
    id: 'Jelaskan tujuan situs, audiens, dan penawaran minimal 40 karakter.',
    vi: 'Mô tả mục đích site, đối tượng và ưu đãi ít nhất 40 ký tự.',
    th: 'อธิบายวัตถุประสงค์ ผู้ชม และข้อเสนอของเว็บอย่างน้อย 40 ตัวอักษร',
    ja: 'サイトの目的・対象・提供内容を40文字以上で書いてください。',
    ko: '사이트 목적·대상·제공 내용을 최소 40자로 적어 주세요.',
  },
  'studio.site.intentChars': {
    'zh-TW': '{n}／≥{min} 字',
    'zh-CN': '{n}／≥{min} 字',
    en: '{n}／≥{min} chars',
    id: '{n}／≥{min} karakter',
    vi: '{n}／≥{min} ký tự',
    th: '{n}／≥{min} ตัวอักษร',
    ja: '{n}／≥{min} 文字',
    ko: '{n}／≥{min}자',
  },
  'studio.site.writeFrontMatter': {
    'zh-TW': '寫入 front matter 到 markdown',
    'zh-CN': '写入 front matter 到 markdown',
    en: 'Write front matter to markdown',
    id: 'Tulis front matter ke markdown',
    vi: 'Ghi front matter vào markdown',
    th: 'เขียน front matter ลง markdown',
    ja: 'front matter を markdown に書き込む',
    ko: 'front matter를 markdown에 쓰기',
  },
  'studio.site.writeTopology': {
    'zh-TW': '寫入 topology 到 markdown',
    'zh-CN': '写入 topology 到 markdown',
    en: 'Write topology to markdown',
    id: 'Tulis topology ke markdown',
    vi: 'Ghi topology vào markdown',
    th: 'เขียน topology ลง markdown',
    ja: 'topology を markdown に書き込む',
    ko: 'topology를 markdown에 쓰기',
  },
  'studio.site.writeIntent': {
    'zh-TW': '寫入 Intent 到 markdown',
    'zh-CN': '写入 Intent 到 markdown',
    en: 'Write Intent to markdown',
    id: 'Tulis Intent ke markdown',
    vi: 'Ghi Intent vào markdown',
    th: 'เขียน Intent ลง markdown',
    ja: 'Intent を markdown に書き込む',
    ko: 'Intent를 markdown에 쓰기',
  },
  'studio.site.projectedLocale': {
    'zh-TW': '投影語系', 'zh-CN': '投影语系', en: 'Projected locale', id: 'Locale terproyeksi', vi: 'Locale đã chiếu', th: 'Locale ที่โปรเจกต์', ja: '投影ロケール', ko: '투영 로케일',
  },
  'studio.site.projectedBrand': {
    'zh-TW': '品牌', 'zh-CN': '品牌', en: 'Brand', id: 'Merek', vi: 'Thương hiệu', th: 'แบรนด์', ja: 'ブランド', ko: '브랜드',
  },
  'studio.site.pages': {
    'zh-TW': '頁面數', 'zh-CN': '页面数', en: 'Pages', id: 'Halaman', vi: 'Trang', th: 'หน้า', ja: 'ページ数', ko: '페이지 수',
  },
  'studio.site.intentLength': {
    'zh-TW': '意圖長度', 'zh-CN': '意图长度', en: 'Intent length', id: 'Panjang Intent', vi: 'Độ dài Intent', th: 'ความยาว Intent', ja: 'Intent の長さ', ko: 'Intent 길이',
  },
  'studio.site.home': {
    'zh-TW': '首頁', 'zh-CN': '首页', en: 'home', id: 'beranda', vi: 'trang chủ', th: 'หน้าแรก', ja: 'ホーム', ko: '홈',
  },
  'studio.site.seoTitle': {
    'zh-TW': 'SEO 標題', 'zh-CN': 'SEO 标题', en: 'SEO title', id: 'Judul SEO', vi: 'Tiêu đề SEO', th: 'ชื่อ SEO', ja: 'SEO タイトル', ko: 'SEO 제목',
  },
  'studio.site.seoDesc': {
    'zh-TW': 'SEO 描述', 'zh-CN': 'SEO 描述', en: 'SEO desc', id: 'Desc SEO', vi: 'Mô tả SEO', th: 'คำอธิบาย SEO', ja: 'SEO 説明', ko: 'SEO 설명',
  },
  'studio.site.issues': {
    'zh-TW': '驗證清單中有 {count} 筆站台問題。',
    'zh-CN': '验证清单中有 {count} 笔站点问题。',
    en: '{count} Site issue(s) in Validation list.',
    id: '{count} isu Site di daftar Validasi.',
    vi: '{count} vấn đề Site trong danh sách Validation.',
    th: 'มีปัญหา Site {count} รายการในรายการ Validation',
    ja: '検証リストにサイト問題が {count} 件あります。',
    ko: '검증 목록에 사이트 이슈 {count}개.',
  },
  'studio.site.modeShort': {
    'zh-TW': '模式', 'zh-CN': '模式', en: 'Mode', id: 'Mode', vi: 'Mode', th: 'โหมด', ja: 'モード', ko: '모드',
  },
  'studio.site.specializeTheme': {
    'zh-TW': 'specialize↔theme', 'zh-CN': 'specialize↔theme', en: 'specialize↔theme', id: 'specialize↔theme', vi: 'specialize↔theme', th: 'specialize↔theme', ja: 'specialize↔theme', ko: 'specialize↔theme',
  },
  'studio.shell.maxWidth': {
    'zh-TW': '最大寬度', 'zh-CN': '最大宽度', en: 'Max width', id: 'Lebar maks', vi: 'Chiều rộng tối đa', th: 'ความกว้างสูงสุด', ja: '最大幅', ko: '최대 너비',
  },
  'studio.shell.canvas': {
    'zh-TW': '畫布', 'zh-CN': '画布', en: 'Canvas', id: 'Kanvas', vi: 'Canvas', th: 'แคนวาส', ja: 'キャンバス', ko: '캔버스',
  },
  'studio.shell.headerMode': {
    'zh-TW': '頁首模式', 'zh-CN': '页首模式', en: 'Header mode', id: 'Mode header', vi: 'Chế độ header', th: 'โหมดส่วนหัว', ja: 'ヘッダーモード', ko: '헤더 모드',
  },
  'studio.shell.headerLayout': {
    'zh-TW': '頁首版型', 'zh-CN': '页首版型', en: 'Header layout', id: 'Layout header', vi: 'Bố cục header', th: 'เลย์เอาต์ส่วนหัว', ja: 'ヘッダーレイアウト', ko: '헤더 레이아웃',
  },
  'studio.shell.mobileMenu': {
    'zh-TW': '行動選單', 'zh-CN': '移动菜单', en: 'Mobile menu', id: 'Menu mobile', vi: 'Menu mobile', th: 'เมนูมือถือ', ja: 'モバイルメニュー', ko: '모바일 메뉴',
  },
  'studio.shell.footerLayout': {
    'zh-TW': '頁尾版型', 'zh-CN': '页尾版型', en: 'Footer layout', id: 'Layout footer', vi: 'Bố cục footer', th: 'เลย์เอาต์ส่วนท้าย', ja: 'フッターレイアウト', ko: '푸터 레이아웃',
  },
  'studio.shell.footerColumns': {
    'zh-TW': '頁尾欄數', 'zh-CN': '页尾栏数', en: 'Footer columns', id: 'Kolom footer', vi: 'Cột footer', th: 'คอลัมน์ส่วนท้าย', ja: 'フッター列数', ko: '푸터 열 수',
  },
  'studio.shell.footerColsShort': {
    'zh-TW': '頁尾欄', 'zh-CN': '页尾栏', en: 'Footer cols', id: 'Kolom footer', vi: 'Cột footer', th: 'คอลัมน์ท้าย', ja: 'フッター列', ko: '푸터 열',
  },
  'studio.shell.sidebarEnabled': {
    'zh-TW': '啟用側欄', 'zh-CN': '启用侧栏', en: 'Sidebar enabled', id: 'Sidebar aktif', vi: 'Bật sidebar', th: 'เปิดแถบข้าง', ja: 'サイドバーを有効', ko: '사이드바 사용',
  },
  'studio.shell.sidebarPosition': {
    'zh-TW': '側欄位置', 'zh-CN': '侧栏位置', en: 'Sidebar position', id: 'Posisi sidebar', vi: 'Vị trí sidebar', th: 'ตำแหน่งแถบข้าง', ja: 'サイドバー位置', ko: '사이드바 위치',
  },
  'studio.shell.sidebarWidth': {
    'zh-TW': '側欄寬度', 'zh-CN': '侧栏宽度', en: 'Sidebar width', id: 'Lebar sidebar', vi: 'Chiều rộng sidebar', th: 'ความกว้างแถบข้าง', ja: 'サイドバー幅', ko: '사이드바 너비',
  },
  'studio.shell.sidebarBehavior': {
    'zh-TW': '側欄行為', 'zh-CN': '侧栏行为', en: 'Sidebar behavior', id: 'Perilaku sidebar', vi: 'Hành vi sidebar', th: 'พฤติกรรมแถบข้าง', ja: 'サイドバー動作', ko: '사이드바 동작',
  },
  'studio.shell.overlayHero': {
    'zh-TW': 'Overlay ↔ hero', 'zh-CN': 'Overlay ↔ hero', en: 'Overlay ↔ hero', id: 'Overlay ↔ hero', vi: 'Overlay ↔ hero', th: 'Overlay ↔ hero', ja: 'Overlay ↔ hero', ko: 'Overlay ↔ hero',
  },
  'studio.shell.writeShell': {
    'zh-TW': '寫入 shell 到 markdown',
    'zh-CN': '写入 shell 到 markdown',
    en: 'Write shell to markdown',
    id: 'Tulis shell ke markdown',
    vi: 'Ghi shell vào markdown',
    th: 'เขียน shell ลง markdown',
    ja: 'shell を markdown に書き込む',
    ko: 'shell을 markdown에 쓰기',
  },
  'studio.shell.navigation': {
    'zh-TW': '導覽', 'zh-CN': '导航', en: 'Navigation', id: 'Navigasi', vi: 'Điều hướng', th: 'การนำทาง', ja: 'ナビゲーション', ko: '내비게이션',
  },
  'studio.shell.navigationHint': {
    'zh-TW': '寫入 # Architecture.navigation（source／maxDepth／showLocalePicker），不更動 shell。',
    'zh-CN': '写入 # Architecture.navigation（source／maxDepth／showLocalePicker），不改动 shell。',
    en: 'Writes # Architecture.navigation (source／maxDepth／showLocalePicker) without touching shell.',
    id: 'Menulis # Architecture.navigation (source／maxDepth／showLocalePicker) tanpa mengubah shell.',
    vi: 'Ghi # Architecture.navigation (source／maxDepth／showLocalePicker) mà không đụng shell.',
    th: 'เขียน # Architecture.navigation (source／maxDepth／showLocalePicker) โดยไม่แตะ shell',
    ja: '# Architecture.navigation（source／maxDepth／showLocalePicker）を書き込み、shell は変更しません。',
    ko: '# Architecture.navigation(source／maxDepth／showLocalePicker)을 쓰며 shell은 건드리지 않습니다.',
  },
  'studio.shell.navSource': {
    'zh-TW': '來源', 'zh-CN': '来源', en: 'Source', id: 'Sumber', vi: 'Nguồn', th: 'แหล่งที่มา', ja: 'ソース', ko: '소스',
  },
  'studio.shell.navMaxDepth': {
    'zh-TW': '最大深度', 'zh-CN': '最大深度', en: 'Max depth', id: 'Kedalaman maks', vi: 'Độ sâu tối đa', th: 'ความลึกสูงสุด', ja: '最大深さ', ko: '최대 깊이',
  },
  'studio.shell.showLocalePicker': {
    'zh-TW': '顯示語系切換', 'zh-CN': '显示语系切换', en: 'Show locale picker', id: 'Tampilkan pemilih locale', vi: 'Hiện bộ chọn locale', th: 'แสดงตัวเลือก locale', ja: 'ロケール切替を表示', ko: '로케일 선택기 표시',
  },
  'studio.shell.writeNavigation': {
    'zh-TW': '寫入 navigation 到 markdown',
    'zh-CN': '写入 navigation 到 markdown',
    en: 'Write navigation to markdown',
    id: 'Tulis navigation ke markdown',
    vi: 'Ghi navigation vào markdown',
    th: 'เขียน navigation ลง markdown',
    ja: 'navigation を markdown に書き込む',
    ko: 'navigation을 markdown에 쓰기',
  },
  'studio.shell.issues': {
    'zh-TW': '驗證清單中有 {count} 筆 Shell 問題。',
    'zh-CN': '验证清单中有 {count} 笔 Shell 问题。',
    en: '{count} Shell issue(s) in Validation list.',
    id: '{count} isu Shell di daftar Validasi.',
    vi: '{count} vấn đề Shell trong danh sách Validation.',
    th: 'มีปัญหา Shell {count} รายการในรายการ Validation',
    ja: '検証リストに Shell 問題が {count} 件あります。',
    ko: '검증 목록에 Shell 이슈 {count}개.',
  },
  'studio.hint.duplicate': {
    'zh-TW': '重複', 'zh-CN': '重复', en: 'duplicate', id: 'duplikat', vi: 'trùng', th: 'ซ้ำ', ja: '重複', ko: '중복',
  },
  'studio.hint.optional': {
    'zh-TW': '選填', 'zh-CN': '选填', en: 'optional', id: 'opsional', vi: 'tuỳ chọn', th: 'ไม่บังคับ', ja: '任意', ko: '선택',
  },
  'studio.hint.kebab': {
    'zh-TW': 'kebab 1–64', 'zh-CN': 'kebab 1–64', en: 'kebab 1–64', id: 'kebab 1–64', vi: 'kebab 1–64', th: 'kebab 1–64', ja: 'kebab 1–64', ko: 'kebab 1–64',
  },
  'studio.hint.intGe0': {
    'zh-TW': '≥0 整數', 'zh-CN': '≥0 整数', en: '≥0 int', id: 'int ≥0', vi: 'số nguyên ≥0', th: 'จำนวนเต็ม ≥0', ja: '≥0 の整数', ko: '≥0 정수',
  },
  'studio.hint.needMediaSlots': {
    'zh-TW': '需要 # Media slots', 'zh-CN': '需要 # Media slots', en: 'need # Media slots', id: 'perlu # Media slots', vi: 'cần # Media slots', th: 'ต้องมี # Media slots', ja: '# Media slots が必要', ko: '# Media slots 필요',
  },
  'studio.hint.gt0': {
    'zh-TW': '> 0', 'zh-CN': '> 0', en: '> 0', id: '> 0', vi: '> 0', th: '> 0', ja: '> 0', ko: '> 0',
  },
  'studio.content.hint': {
    'zh-TW': '完整 Content 回寫：FAQ／albums／videos／forms／products／news。Section 面板另開。',
    'zh-CN': '完整 Content 回写：FAQ／albums／videos／forms／products／news。Section 面板另开。',
    en: 'Full Content write-back: FAQ／albums／videos／forms／products／news. Section panel remains separate.',
    id: 'Write-back Content penuh: FAQ／albums／videos／forms／products／news. Panel Section terpisah.',
    vi: 'Ghi lại Content đầy đủ: FAQ／albums／videos／forms／products／news. Panel Section riêng.',
    th: 'เขียน Content ครบ: FAQ／albums／videos／forms／products／news แผง Section แยกต่างหาก',
    ja: 'Content の完全書き戻し：FAQ／albums／videos／forms／products／news。Section パネルは別。',
    ko: 'Content 전체 쓰기: FAQ／albums／videos／forms／products／news. Section 패널은 별도.',
  },
  'studio.content.faq': {
    'zh-TW': 'FAQ', 'zh-CN': 'FAQ', en: 'FAQ', id: 'FAQ', vi: 'FAQ', th: 'FAQ', ja: 'FAQ', ko: 'FAQ',
  },
  'studio.content.faqRenderAs': {
    'zh-TW': 'FAQ renderAs', 'zh-CN': 'FAQ renderAs', en: 'FAQ renderAs', id: 'FAQ renderAs', vi: 'FAQ renderAs', th: 'FAQ renderAs', ja: 'FAQ renderAs', ko: 'FAQ renderAs',
  },
  'studio.content.questionN': {
    'zh-TW': 'Q{n}', 'zh-CN': 'Q{n}', en: 'Q{n}', id: 'Q{n}', vi: 'Q{n}', th: 'Q{n}', ja: 'Q{n}', ko: 'Q{n}',
  },
  'studio.content.answerN': {
    'zh-TW': 'A{n}', 'zh-CN': 'A{n}', en: 'A{n}', id: 'A{n}', vi: 'A{n}', th: 'A{n}', ja: 'A{n}', ko: 'A{n}',
  },
  'studio.content.remove': {
    'zh-TW': '移除', 'zh-CN': '移除', en: 'Remove', id: 'Hapus', vi: 'Xoá', th: 'ลบ', ja: '削除', ko: '제거',
  },
  'studio.content.addFaq': {
    'zh-TW': '新增 FAQ 項目', 'zh-CN': '新增 FAQ 项目', en: 'Add FAQ item', id: 'Tambah item FAQ', vi: 'Thêm mục FAQ', th: 'เพิ่มรายการ FAQ', ja: 'FAQ 項目を追加', ko: 'FAQ 항목 추가',
  },
  'studio.content.writeFaq': {
    'zh-TW': '寫入 FAQ 到 markdown', 'zh-CN': '写入 FAQ 到 markdown', en: 'Write FAQ to markdown', id: 'Tulis FAQ ke markdown', vi: 'Ghi FAQ vào markdown', th: 'เขียน FAQ ลง markdown', ja: 'FAQ を markdown に書き込む', ko: 'FAQ를 markdown에 쓰기',
  },
  'studio.content.albums': {
    'zh-TW': '相簿', 'zh-CN': '相册', en: 'Albums', id: 'Album', vi: 'Albums', th: 'อัลบั้ม', ja: 'アルバム', ko: '앨범',
  },
  'studio.content.albumMediaSummary': {
    'zh-TW': 'mediaSlots {req}／Media {media}',
    'zh-CN': 'mediaSlots {req}／Media {media}',
    en: 'mediaSlots {req}／Media {media}',
    id: 'mediaSlots {req}／Media {media}',
    vi: 'mediaSlots {req}／Media {media}',
    th: 'mediaSlots {req}／Media {media}',
    ja: 'mediaSlots {req}／Media {media}',
    ko: 'mediaSlots {req}／Media {media}',
  },
  'studio.content.key': {
    'zh-TW': 'key', 'zh-CN': 'key', en: 'key', id: 'key', vi: 'key', th: 'key', ja: 'key', ko: 'key',
  },
  'studio.content.title': {
    'zh-TW': '標題', 'zh-CN': '标题', en: 'title', id: 'judul', vi: 'tiêu đề', th: 'ชื่อ', ja: 'タイトル', ko: '제목',
  },
  'studio.content.access': {
    'zh-TW': '存取', 'zh-CN': '访问', en: 'access', id: 'akses', vi: 'truy cập', th: 'การเข้าถึง', ja: 'アクセス', ko: '접근',
  },
  'studio.content.mediaSlots': {
    'zh-TW': 'mediaSlots', 'zh-CN': 'mediaSlots', en: 'mediaSlots', id: 'mediaSlots', vi: 'mediaSlots', th: 'mediaSlots', ja: 'mediaSlots', ko: 'mediaSlots',
  },
  'studio.content.removeAlbum': {
    'zh-TW': '移除相簿', 'zh-CN': '移除相册', en: 'Remove album', id: 'Hapus album', vi: 'Xoá album', th: 'ลบอัลบั้ม', ja: 'アルバムを削除', ko: '앨범 제거',
  },
  'studio.content.addAlbum': {
    'zh-TW': '新增相簿', 'zh-CN': '新增相册', en: 'Add album', id: 'Tambah album', vi: 'Thêm album', th: 'เพิ่มอัลบั้ม', ja: 'アルバムを追加', ko: '앨범 추가',
  },
  'studio.content.writeAlbums': {
    'zh-TW': '寫入 albums 到 markdown', 'zh-CN': '写入 albums 到 markdown', en: 'Write albums to markdown', id: 'Tulis albums ke markdown', vi: 'Ghi albums vào markdown', th: 'เขียน albums ลง markdown', ja: 'albums を markdown に書き込む', ko: 'albums를 markdown에 쓰기',
  },
  'studio.content.videos': {
    'zh-TW': '影片', 'zh-CN': '视频', en: 'Videos', id: 'Video', vi: 'Videos', th: 'วิดีโอ', ja: '動画', ko: '동영상',
  },
  'studio.content.slug': {
    'zh-TW': 'slug', 'zh-CN': 'slug', en: 'slug', id: 'slug', vi: 'slug', th: 'slug', ja: 'slug', ko: 'slug',
  },
  'studio.content.source': {
    'zh-TW': '來源', 'zh-CN': '来源', en: 'source', id: 'sumber', vi: 'nguồn', th: 'แหล่ง', ja: 'ソース', ko: '소스',
  },
  'studio.content.removeVideo': {
    'zh-TW': '移除影片', 'zh-CN': '移除视频', en: 'Remove video', id: 'Hapus video', vi: 'Xoá video', th: 'ลบวิดีโอ', ja: '動画を削除', ko: '동영상 제거',
  },
  'studio.content.addVideo': {
    'zh-TW': '新增影片', 'zh-CN': '新增视频', en: 'Add video', id: 'Tambah video', vi: 'Thêm video', th: 'เพิ่มวิดีโอ', ja: '動画を追加', ko: '동영상 추가',
  },
  'studio.content.writeVideos': {
    'zh-TW': '寫入 videos 到 markdown', 'zh-CN': '写入 videos 到 markdown', en: 'Write videos to markdown', id: 'Tulis videos ke markdown', vi: 'Ghi videos vào markdown', th: 'เขียน videos ลง markdown', ja: 'videos を markdown に書き込む', ko: 'videos를 markdown에 쓰기',
  },
  'studio.content.forms': {
    'zh-TW': '表單', 'zh-CN': '表单', en: 'Forms', id: 'Form', vi: 'Forms', th: 'ฟอร์ม', ja: 'フォーム', ko: '폼',
  },
  'studio.content.formKey': {
    'zh-TW': 'formKey', 'zh-CN': 'formKey', en: 'formKey', id: 'formKey', vi: 'formKey', th: 'formKey', ja: 'formKey', ko: 'formKey',
  },
  'studio.content.fields': {
    'zh-TW': '欄位', 'zh-CN': '字段', en: 'fields', id: 'fields', vi: 'fields', th: 'ฟิลด์', ja: 'フィールド', ko: '필드',
  },
  'studio.content.removeForm': {
    'zh-TW': '移除表單', 'zh-CN': '移除表单', en: 'Remove form', id: 'Hapus form', vi: 'Xoá form', th: 'ลบฟอร์ม', ja: 'フォームを削除', ko: '폼 제거',
  },
  'studio.content.addForm': {
    'zh-TW': '新增表單', 'zh-CN': '新增表单', en: 'Add form', id: 'Tambah form', vi: 'Thêm form', th: 'เพิ่มฟอร์ม', ja: 'フォームを追加', ko: '폼 추가',
  },
  'studio.content.writeForms': {
    'zh-TW': '寫入 forms 到 markdown', 'zh-CN': '写入 forms 到 markdown', en: 'Write forms to markdown', id: 'Tulis forms ke markdown', vi: 'Ghi forms vào markdown', th: 'เขียน forms ลง markdown', ja: 'forms を markdown に書き込む', ko: 'forms를 markdown에 쓰기',
  },
  'studio.content.products': {
    'zh-TW': '商品', 'zh-CN': '商品', en: 'Products', id: 'Produk', vi: 'Sản phẩm', th: 'สินค้า', ja: '商品', ko: '상품',
  },
  'studio.content.sku': {
    'zh-TW': 'sku', 'zh-CN': 'sku', en: 'sku', id: 'sku', vi: 'sku', th: 'sku', ja: 'sku', ko: 'sku',
  },
  'studio.content.name': {
    'zh-TW': '名稱', 'zh-CN': '名称', en: 'name', id: 'nama', vi: 'tên', th: 'ชื่อ', ja: '名前', ko: '이름',
  },
  'studio.content.price': {
    'zh-TW': '價格', 'zh-CN': '价格', en: 'price', id: 'harga', vi: 'giá', th: 'ราคา', ja: '価格', ko: '가격',
  },
  'studio.content.category': {
    'zh-TW': '分類', 'zh-CN': '分类', en: 'category', id: 'kategori', vi: 'danh mục', th: 'หมวด', ja: 'カテゴリ', ko: '카테고리',
  },
  'studio.content.imageSlots': {
    'zh-TW': 'imageSlots', 'zh-CN': 'imageSlots', en: 'imageSlots', id: 'imageSlots', vi: 'imageSlots', th: 'imageSlots', ja: 'imageSlots', ko: 'imageSlots',
  },
  'studio.content.removeProduct': {
    'zh-TW': '移除商品', 'zh-CN': '移除商品', en: 'Remove product', id: 'Hapus produk', vi: 'Xoá sản phẩm', th: 'ลบสินค้า', ja: '商品を削除', ko: '상품 제거',
  },
  'studio.content.addProduct': {
    'zh-TW': '新增商品', 'zh-CN': '新增商品', en: 'Add product', id: 'Tambah produk', vi: 'Thêm sản phẩm', th: 'เพิ่มสินค้า', ja: '商品を追加', ko: '상품 추가',
  },
  'studio.content.writeProducts': {
    'zh-TW': '寫入 products 到 markdown', 'zh-CN': '写入 products 到 markdown', en: 'Write products to markdown', id: 'Tulis products ke markdown', vi: 'Ghi products vào markdown', th: 'เขียน products ลง markdown', ja: 'products を markdown に書き込む', ko: 'products를 markdown에 쓰기',
  },
  'studio.content.news': {
    'zh-TW': '新聞', 'zh-CN': '新闻', en: 'News', id: 'Berita', vi: 'Tin tức', th: 'ข่าว', ja: 'ニュース', ko: '뉴스',
  },
  'studio.content.removeNews': {
    'zh-TW': '移除新聞', 'zh-CN': '移除新闻', en: 'Remove news', id: 'Hapus berita', vi: 'Xoá tin', th: 'ลบข่าว', ja: 'ニュースを削除', ko: '뉴스 제거',
  },
  'studio.content.addNews': {
    'zh-TW': '新增新聞', 'zh-CN': '新增新闻', en: 'Add news', id: 'Tambah berita', vi: 'Thêm tin', th: 'เพิ่มข่าว', ja: 'ニュースを追加', ko: '뉴스 추가',
  },
  'studio.content.writeNews': {
    'zh-TW': '寫入 news 到 markdown', 'zh-CN': '写入 news 到 markdown', en: 'Write news to markdown', id: 'Tulis news ke markdown', vi: 'Ghi news vào markdown', th: 'เขียน news ลง markdown', ja: 'news を markdown に書き込む', ko: 'news를 markdown에 쓰기',
  },
  'studio.content.faqItems': {
    'zh-TW': 'FAQ 項目', 'zh-CN': 'FAQ 项目', en: 'FAQ items', id: 'Item FAQ', vi: 'Mục FAQ', th: 'รายการ FAQ', ja: 'FAQ 項目', ko: 'FAQ 항목',
  },
  'studio.content.summaryKeys': {
    'zh-TW': 'keys', 'zh-CN': 'keys', en: 'keys', id: 'keys', vi: 'keys', th: 'keys', ja: 'keys', ko: 'keys',
  },
  'studio.content.summaryTitles': {
    'zh-TW': 'titles', 'zh-CN': 'titles', en: 'titles', id: 'titles', vi: 'titles', th: 'titles', ja: 'titles', ko: 'titles',
  },
  'studio.content.summarySlotCounts': {
    'zh-TW': 'slotCounts', 'zh-CN': 'slotCounts', en: 'slotCounts', id: 'slotCounts', vi: 'slotCounts', th: 'slotCounts', ja: 'slotCounts', ko: 'slotCounts',
  },
  'studio.content.summarySlugs': {
    'zh-TW': 'slugs', 'zh-CN': 'slugs', en: 'slugs', id: 'slugs', vi: 'slugs', th: 'slugs', ja: 'slugs', ko: 'slugs',
  },
  'studio.content.summaryFormKeys': {
    'zh-TW': 'formKeys', 'zh-CN': 'formKeys', en: 'formKeys', id: 'formKeys', vi: 'formKeys', th: 'formKeys', ja: 'formKeys', ko: 'formKeys',
  },
  'studio.content.summaryPrices': {
    'zh-TW': 'prices', 'zh-CN': 'prices', en: 'prices', id: 'prices', vi: 'prices', th: 'prices', ja: 'prices', ko: 'prices',
  },
  'studio.content.summaryNames': {
    'zh-TW': 'names', 'zh-CN': 'names', en: 'names', id: 'names', vi: 'names', th: 'names', ja: 'names', ko: 'names',
  },
  'studio.content.summaryCategories': {
    'zh-TW': 'categories', 'zh-CN': 'categories', en: 'categories', id: 'categories', vi: 'categories', th: 'categories', ja: 'categories', ko: 'categories',
  },
  'studio.content.summarySkus': {
    'zh-TW': 'skus', 'zh-CN': 'skus', en: 'skus', id: 'skus', vi: 'skus', th: 'skus', ja: 'skus', ko: 'skus',
  },
  'studio.content.issues': {
    'zh-TW': '驗證清單中有 {count} 筆 Content 問題。',
    'zh-CN': '验证清单中有 {count} 笔 Content 问题。',
    en: '{count} Content issue(s) in Validation list.',
    id: '{count} isu Content di daftar Validasi.',
    vi: '{count} vấn đề Content trong danh sách Validation.',
    th: 'มีปัญหา Content {count} รายการในรายการ Validation',
    ja: '検証リストに Content 問題が {count} 件あります。',
    ko: '검증 목록에 Content 이슈 {count}개.',
  },
  'studio.design.publishContrast': {
    'zh-TW': '發布對比', 'zh-CN': '发布对比', en: 'Publish contrast', id: 'Kontras publish', vi: 'Tương phản publish', th: 'คอนทราสต์เผยแพร่', ja: '公開コントラスト', ko: '게시 대비',
  },
  'studio.design.paletteHex': {
    'zh-TW': '調色盤 hex', 'zh-CN': '调色盘 hex', en: 'Palette hex', id: 'Hex palet', vi: 'Hex palette', th: 'hex พาเลต', ja: 'パレット hex', ko: '팔레트 hex',
  },
  'studio.design.radius': {
    'zh-TW': '圓角', 'zh-CN': '圆角', en: 'Radius', id: 'Radius', vi: 'Radius', th: 'รัศมี', ja: '角丸', ko: '모서리',
  },
  'studio.design.shadow': {
    'zh-TW': '陰影', 'zh-CN': '阴影', en: 'Shadow', id: 'Bayangan', vi: 'Đổ bóng', th: 'เงา', ja: '影', ko: '그림자',
  },
  'studio.design.motion': {
    'zh-TW': '動效', 'zh-CN': '动效', en: 'Motion', id: 'Motion', vi: 'Motion', th: 'โมชัน', ja: 'モーション', ko: '모션',
  },
  'studio.design.cjkFont': {
    'zh-TW': 'CJK 字型', 'zh-CN': 'CJK 字体', en: 'CJK font', id: 'Font CJK', vi: 'Font CJK', th: 'ฟอนต์ CJK', ja: 'CJK フォント', ko: 'CJK 글꼴',
  },
  'studio.design.cjkShort': {
    'zh-TW': 'CJK', 'zh-CN': 'CJK', en: 'CJK', id: 'CJK', vi: 'CJK', th: 'CJK', ja: 'CJK', ko: 'CJK',
  },
  'studio.design.headingFont': {
    'zh-TW': '標題字型', 'zh-CN': '标题字体', en: 'Heading font', id: 'Font heading', vi: 'Font heading', th: 'ฟอนต์หัวข้อ', ja: '見出しフォント', ko: '제목 글꼴',
  },
  'studio.design.bodyFont': {
    'zh-TW': '內文字型', 'zh-CN': '正文字体', en: 'Body font', id: 'Font body', vi: 'Font body', th: 'ฟอนต์เนื้อหา', ja: '本文フォント', ko: '본문 글꼴',
  },
  'studio.design.typeScaleClamp': {
    'zh-TW': '字級 clamp', 'zh-CN': '字号 clamp', en: 'Type-scale clamp', id: 'Clamp type-scale', vi: 'Clamp type-scale', th: 'clamp ขนาดตัวอักษร', ja: 'タイプスケール clamp', ko: '타입 스케일 clamp',
  },
  'studio.design.density': {
    'zh-TW': '密度', 'zh-CN': '密度', en: 'Density', id: 'Densitas', vi: 'Mật độ', th: 'ความหนาแน่น', ja: '密度', ko: '밀도',
  },
  'studio.design.typeScale': {
    'zh-TW': '字級', 'zh-CN': '字号', en: 'Type scale', id: 'Type scale', vi: 'Type scale', th: 'ขนาดตัวอักษร', ja: 'タイプスケール', ko: '타입 스케일',
  },
  'studio.design.fontWeight': {
    'zh-TW': '字重', 'zh-CN': '字重', en: 'Font weight', id: 'Bobot font', vi: 'Độ đậm font', th: 'น้ำหนักฟอนต์', ja: 'フォントウェイト', ko: '글꼴 굵기',
  },
  'studio.design.h1Prefix': {
    'zh-TW': 'h1', 'zh-CN': 'h1', en: 'h1', id: 'h1', vi: 'h1', th: 'h1', ja: 'h1', ko: 'h1',
  },
  'studio.design.clampViewportsAria': {
    'zh-TW': '字級 clamp 視窗', 'zh-CN': '字号 clamp 视窗', en: 'Type-scale clamp viewports', id: 'Viewport clamp type-scale', vi: 'Viewport clamp type-scale', th: 'viewport ของ clamp', ja: 'タイプスケール clamp のビューポート', ko: '타입 스케일 clamp 뷰포트',
  },
  'studio.design.palette': {
    'zh-TW': '調色盤', 'zh-CN': '调色盘', en: 'Palette', id: 'Palet', vi: 'Palette', th: 'พาเลต', ja: 'パレット', ko: '팔레트',
  },
  'studio.design.typography': {
    'zh-TW': '字型', 'zh-CN': '字体', en: 'Typography', id: 'Tipografi', vi: 'Typography', th: 'Typography', ja: 'タイポグラフィ', ko: '타이포그래피',
  },
  'studio.design.shapeMotion': {
    'zh-TW': '形狀與動效', 'zh-CN': '形状与动效', en: 'Shape & motion', id: 'Bentuk & motion', vi: 'Hình dạng & motion', th: 'รูปทรงและโมชัน', ja: '形状とモーション', ko: '형태와 모션',
  },
  'studio.design.cardRadius': {
    'zh-TW': '卡片圓角', 'zh-CN': '卡片圆角', en: 'Card radius', id: 'Radius kartu', vi: 'Radius thẻ', th: 'รัศมีการ์ด', ja: 'カード角丸', ko: '카드 모서리',
  },
  'studio.design.cardShadow': {
    'zh-TW': '卡片陰影', 'zh-CN': '卡片阴影', en: 'Card shadow', id: 'Bayangan kartu', vi: 'Đổ bóng thẻ', th: 'เงาการ์ด', ja: 'カード影', ko: '카드 그림자',
  },
  'studio.design.spacing': {
    'zh-TW': '間距', 'zh-CN': '间距', en: 'Spacing', id: 'Spasi', vi: 'Khoảng cách', th: 'ระยะห่าง', ja: 'スペーシング', ko: '간격',
  },
  'studio.design.write': {
    'zh-TW': '寫入 markdown',
    'zh-CN': '写入 markdown',
    en: 'Write to markdown',
    id: 'Tulis ke markdown',
    vi: 'Ghi vào markdown',
    th: 'เขียนลง markdown',
    ja: 'markdown に書き込む',
    ko: 'markdown에 쓰기',
  },
  'studio.design.issues': {
    'zh-TW': '驗證清單中有 {count} 筆 Design 問題。',
    'zh-CN': '验证清单中有 {count} 笔 Design 问题。',
    en: '{count} Design issue(s) in Validation list.',
    id: '{count} isu Design di daftar Validasi.',
    vi: '{count} vấn đề Design trong danh sách Validation.',
    th: 'มีปัญหา Design {count} รายการในรายการ Validation',
    ja: '検証リストに Design 問題が {count} 件あります。',
    ko: '검증 목록에 Design 이슈 {count}개.',
  },
  'studio.page.hint': {
    'zh-TW': '寫入 # Pages：id／slug／title／isHome／layout.type＋layout params（純量或 columns.desktop 點路徑巢狀）／sections／seo。更深巢狀仍只在 Markdown。',
    'zh-CN': '写入 # Pages：id／slug／title／isHome／layout.type＋layout params（标量或 columns.desktop 点路径嵌套）／sections／seo。更深嵌套仍只在 Markdown。',
    en: 'Write # Pages entries: id／slug／title／isHome／layout.type＋layout params（scalar or columns.desktop dotted nested）／sections／seo. Deeper nesting stays Markdown-only.',
    id: 'Tulis entri # Pages: id／slug／title／isHome／layout.type＋layout params（skalar atau columns.desktop bertingkat）／sections／seo. Nesting lebih dalam tetap Markdown saja.',
    vi: 'Ghi # Pages: id／slug／title／isHome／layout.type＋layout params（scalar hoặc columns.desktop lồng）／sections／seo. Lồng sâu hơn chỉ trong Markdown.',
    th: 'เขียน # Pages: id／slug／title／isHome／layout.type＋layout params（สเกลาร์หรือ columns.desktop แบบจุด）／sections／seo การซ้อนลึกกว่ายังอยู่ใน Markdown เท่านั้น',
    ja: '# Pages を書き込み：id／slug／title／isHome／layout.type＋layout params（スカラーまたは columns.desktop の点ネスト）／sections／seo。より深いネストは Markdown のみ。',
    ko: '# Pages 작성: id／slug／title／isHome／layout.type＋layout params（스칼라 또는 columns.desktop 점 중첩）／sections／seo. 더 깊은 중첩은 Markdown만.',
  },
  'studio.page.id': {
    'zh-TW': 'Id', 'zh-CN': 'Id', en: 'Id', id: 'Id', vi: 'Id', th: 'Id', ja: 'Id', ko: 'Id',
  },
  'studio.page.slug': {
    'zh-TW': 'Slug', 'zh-CN': 'Slug', en: 'Slug', id: 'Slug', vi: 'Slug', th: 'Slug', ja: 'Slug', ko: 'Slug',
  },
  'studio.page.title': {
    'zh-TW': '標題', 'zh-CN': '标题', en: 'Title', id: 'Judul', vi: 'Tiêu đề', th: 'ชื่อ', ja: 'タイトル', ko: '제목',
  },
  'studio.page.isHome': {
    'zh-TW': 'isHome', 'zh-CN': 'isHome', en: 'isHome', id: 'isHome', vi: 'isHome', th: 'isHome', ja: 'isHome', ko: 'isHome',
  },
  'studio.page.homeMustBeRoot': {
    'zh-TW': '首頁必須為 /', 'zh-CN': '首页必须为 /', en: 'home must be /', id: 'home harus /', vi: 'home phải là /', th: 'home ต้องเป็น /', ja: 'home は / 必須', ko: 'home은 / 여야 함',
  },
  'studio.page.handFillSlug': {
    'zh-TW': '請手填 slug', 'zh-CN': '请手填 slug', en: 'hand-fill slug', id: 'isi slug manual', vi: 'điền slug thủ công', th: 'กรอก slug เอง', ja: 'slug を手入力', ko: 'slug 수동 입력',
  },
  'studio.page.nonAsciiNeedsSlug': {
    'zh-TW': '非 ASCII 標題需 slug', 'zh-CN': '非 ASCII 标题需 slug', en: 'non-ASCII needs slug', id: 'non-ASCII perlu slug', vi: 'non-ASCII cần slug', th: 'non-ASCII ต้องมี slug', ja: '非 ASCII には slug が必要', ko: '비 ASCII는 slug 필요',
  },
  'studio.page.layoutType': {
    'zh-TW': '版型類型', 'zh-CN': '版型类型', en: 'Layout type', id: 'Tipe layout', vi: 'Loại layout', th: 'ชนิดเลย์เอาต์', ja: 'レイアウト種別', ko: '레이아웃 유형',
  },
  'studio.page.alts': {
    'zh-TW': '替代', 'zh-CN': '替代', en: 'alts', id: 'alts', vi: 'alts', th: 'ทางเลือก', ja: '代替', ko: '대안',
  },
  'studio.page.needsTwoSections': {
    'zh-TW': '需要 ≥2 個 sections', 'zh-CN': '需要 ≥2 个 sections', en: 'needs ≥2 sections', id: 'perlu ≥2 sections', vi: 'cần ≥2 sections', th: 'ต้องมี ≥2 sections', ja: 'sections が ≥2 必要', ko: 'sections ≥2 필요',
  },
  'studio.page.layoutParams': {
    'zh-TW': 'Layout params（每行 key: value；僅純量）',
    'zh-CN': 'Layout params（每行 key: value；仅标量）',
    en: 'Layout params (key: value per line; scalars only)',
    id: 'Layout params (key: value per baris; hanya skalar)',
    vi: 'Layout params (key: value mỗi dòng; chỉ scalar)',
    th: 'Layout params (key: value ต่อบรรทัด; สเกลาร์เท่านั้น)',
    ja: 'Layout params（行ごと key: value；スカラーのみ）',
    ko: 'Layout params(줄마다 key: value; 스칼라만)',
  },
  'studio.page.sections': {
    'zh-TW': 'Sections（逗號分隔 id）',
    'zh-CN': 'Sections（逗号分隔 id）',
    en: 'Sections (comma-separated ids)',
    id: 'Sections (id dipisah koma)',
    vi: 'Sections (id cách bằng dấu phẩy)',
    th: 'Sections (id คั่นด้วยจุลภาค)',
    ja: 'Sections（カンマ区切り id）',
    ko: 'Sections(쉼표 구분 id)',
  },
  'studio.page.sectionsShort': {
    'zh-TW': 'sections', 'zh-CN': 'sections', en: 'sections', id: 'sections', vi: 'sections', th: 'sections', ja: 'sections', ko: 'sections',
  },
  'studio.page.missing': {
    'zh-TW': '缺少', 'zh-CN': '缺少', en: 'missing', id: 'hilang', vi: 'thiếu', th: 'ขาด', ja: '不足', ko: '누락',
  },
  'studio.page.seoTitle': {
    'zh-TW': 'SEO 標題', 'zh-CN': 'SEO 标题', en: 'SEO title', id: 'Judul SEO', vi: 'Tiêu đề SEO', th: 'ชื่อ SEO', ja: 'SEO タイトル', ko: 'SEO 제목',
  },
  'studio.page.seoDescription': {
    'zh-TW': 'SEO 描述', 'zh-CN': 'SEO 描述', en: 'SEO description', id: 'Deskripsi SEO', vi: 'Mô tả SEO', th: 'คำอธิบาย SEO', ja: 'SEO 説明', ko: 'SEO 설명',
  },
  'studio.page.remove': {
    'zh-TW': '移除', 'zh-CN': '移除', en: 'Remove', id: 'Hapus', vi: 'Xoá', th: 'ลบ', ja: '削除', ko: '제거',
  },
  'studio.page.add': {
    'zh-TW': '新增頁面', 'zh-CN': '新增页面', en: 'Add page', id: 'Tambah halaman', vi: 'Thêm trang', th: 'เพิ่มหน้า', ja: 'ページを追加', ko: '페이지 추가',
  },
  'studio.page.write': {
    'zh-TW': '寫入 pages 到 markdown',
    'zh-CN': '写入 pages 到 markdown',
    en: 'Write pages to markdown',
    id: 'Tulis pages ke markdown',
    vi: 'Ghi pages vào markdown',
    th: 'เขียน pages ลง markdown',
    ja: 'pages を markdown に書き込む',
    ko: 'pages를 markdown에 쓰기',
  },
  'studio.page.home': {
    'zh-TW': '首頁', 'zh-CN': '首页', en: 'home', id: 'beranda', vi: 'trang chủ', th: 'หน้าแรก', ja: 'ホーム', ko: '홈',
  },
  'studio.page.depth': {
    'zh-TW': '深度', 'zh-CN': '深度', en: 'depth', id: 'kedalaman', vi: 'độ sâu', th: 'ความลึก', ja: '深さ', ko: '깊이',
  },
  'studio.page.layout': {
    'zh-TW': '版型', 'zh-CN': '版型', en: 'layout', id: 'layout', vi: 'layout', th: 'เลย์เอาต์', ja: 'レイアウト', ko: '레이아웃',
  },
  'studio.page.seoDescShort': {
    'zh-TW': 'SEO 描述', 'zh-CN': 'SEO 描述', en: 'SEO desc', id: 'Desc SEO', vi: 'Mô tả SEO', th: 'คำอธิบาย SEO', ja: 'SEO 説明', ko: 'SEO 설명',
  },
  'studio.page.issues': {
    'zh-TW': '驗證清單中有 {count} 筆 Page 問題。',
    'zh-CN': '验证清单中有 {count} 笔 Page 问题。',
    en: '{count} Page issue(s) in Validation list.',
    id: '{count} isu Page di daftar Validasi.',
    vi: '{count} vấn đề Page trong danh sách Validation.',
    th: 'มีปัญหา Page {count} รายการในรายการ Validation',
    ja: '検証リストに Page 問題が {count} 件あります。',
    ko: '검증 목록에 Page 이슈 {count}개.',
  },
  'studio.seo.siteTitle': {
    'zh-TW': '站台標題', 'zh-CN': '站点标题', en: 'Site title', id: 'Judul situs', vi: 'Tiêu đề site', th: 'ชื่อไซต์', ja: 'サイトタイトル', ko: '사이트 제목',
  },
  'studio.seo.siteDescription': {
    'zh-TW': '站台描述', 'zh-CN': '站点描述', en: 'Site description', id: 'Deskripsi situs', vi: 'Mô tả site', th: 'คำอธิบายไซต์', ja: 'サイト説明', ko: '사이트 설명',
  },
  'studio.seo.write': {
    'zh-TW': '寫入 markdown',
    'zh-CN': '写入 markdown',
    en: 'Write to markdown',
    id: 'Tulis ke markdown',
    vi: 'Ghi vào markdown',
    th: 'เขียนลง markdown',
    ja: 'markdown に書き込む',
    ko: 'markdown에 쓰기',
  },
  'studio.seo.locale': {
    'zh-TW': '語系', 'zh-CN': '语系', en: 'Locale', id: 'Locale', vi: 'Locale', th: 'Locale', ja: 'ロケール', ko: '로케일',
  },
  'studio.seo.htmlLang': {
    'zh-TW': 'html lang', 'zh-CN': 'html lang', en: 'html lang', id: 'html lang', vi: 'html lang', th: 'html lang', ja: 'html lang', ko: 'html lang',
  },
  'studio.seo.dir': {
    'zh-TW': 'dir', 'zh-CN': 'dir', en: 'dir', id: 'dir', vi: 'dir', th: 'dir', ja: 'dir', ko: 'dir',
  },
  'studio.seo.hreflangPolicy': {
    'zh-TW': 'Hreflang 策略', 'zh-CN': 'Hreflang 策略', en: 'Hreflang policy', id: 'Kebijakan hreflang', vi: 'Chính sách hreflang', th: 'นโยบาย hreflang', ja: 'Hreflang ポリシー', ko: 'Hreflang 정책',
  },
  'studio.seo.hreflangNote': {
    'zh-TW': 'Hreflang 由語系對應 self + x-default（SkillLocaleDomMap）。請在 Site 面板變更語系。',
    'zh-CN': 'Hreflang 由语系映射 self + x-default（SkillLocaleDomMap）。请在 Site 面板变更语系。',
    en: 'Hreflang is self + x-default from locale (SkillLocaleDomMap). Change locale in the Site panel.',
    id: 'Hreflang adalah self + x-default dari locale (SkillLocaleDomMap). Ubah locale di panel Site.',
    vi: 'Hreflang là self + x-default từ locale (SkillLocaleDomMap). Đổi locale ở panel Site.',
    th: 'Hreflang คือ self + x-default จาก locale (SkillLocaleDomMap) เปลี่ยน locale ในแผง Site',
    ja: 'Hreflang は locale から self + x-default（SkillLocaleDomMap）。Site パネルで locale を変更してください。',
    ko: 'Hreflang은 locale의 self + x-default(SkillLocaleDomMap)입니다. Site 패널에서 locale을 바꾸세요.',
  },
  'studio.seo.issues': {
    'zh-TW': '驗證清單中有 {count} 筆 SEO 問題。',
    'zh-CN': '验证清单中有 {count} 笔 SEO 问题。',
    en: '{count} SEO issue(s) in Validation list.',
    id: '{count} isu SEO di daftar Validasi.',
    vi: '{count} vấn đề SEO trong danh sách Validation.',
    th: 'มีปัญหา SEO {count} รายการในรายการ Validation',
    ja: '検証リストに SEO 問題が {count} 件あります。',
    ko: '검증 목록에 SEO 이슈 {count}개.',
  },
  'studio.media.hint': {
    'zh-TW': '編輯宣告的 # Media slots。有撰寫時 purpose 不可空白（≤200）；alt／composition／forbidden 有填時長度 1–200。重複 slotId 會被 parser 拒絕。',
    'zh-CN': '编辑声明的 # Media slots。有撰写时 purpose 不可空白（≤200）；alt／composition／forbidden 有填时长度 1–200。重复 slotId 会被 parser 拒绝。',
    en: 'Edit declared # Media slots. Purpose should be non-empty (≤200) when the slot is authored; alt／composition／forbidden length 1–200 when set. Duplicate slotId is refused by the parser.',
    id: 'Edit slot # Media yang dideklarasikan. Purpose harus non-kosong (≤200) saat slot ditulis; alt／composition／forbidden panjang 1–200 jika diisi. slotId duplikat ditolak parser.',
    vi: 'Sửa các # Media slots đã khai báo. Purpose không được trống (≤200) khi viết slot; alt／composition／forbidden dài 1–200 khi có. slotId trùng bị parser từ chối.',
    th: 'แก้ไข # Media slots ที่ประกาศ purpose ต้องไม่ว่าง (≤200) เมื่อเขียนสล็อต; alt／composition／forbidden ยาว 1–200 เมื่อมี ค่า slotId ซ้ำถูก parser ปฏิเสธ',
    ja: '宣言済み # Media slots を編集。スロット作成時 purpose は空不可（≤200）；alt／composition／forbidden は設定時 1–200。重複 slotId は parser が拒否。',
    ko: '선언된 # Media slots 편집. 슬롯 작성 시 purpose는 비우면 안 됨(≤200); alt／composition／forbidden은 설정 시 1–200. 중복 slotId는 parser가 거부.',
  },
  'studio.media.slotId': {
    'zh-TW': 'slotId', 'zh-CN': 'slotId', en: 'slotId', id: 'slotId', vi: 'slotId', th: 'slotId', ja: 'slotId', ko: 'slotId',
  },
  'studio.media.aspect': {
    'zh-TW': 'aspect', 'zh-CN': 'aspect', en: 'aspect', id: 'aspect', vi: 'aspect', th: 'aspect', ja: 'aspect', ko: 'aspect',
  },
  'studio.media.custom': {
    'zh-TW': '自訂', 'zh-CN': '自定义', en: 'custom', id: 'kustom', vi: 'tuỳ chỉnh', th: 'กำหนดเอง', ja: 'カスタム', ko: '사용자 지정',
  },
  'studio.media.aspectOption': {
    'zh-TW': '{aspect} ({kind})',
    'zh-CN': '{aspect} ({kind})',
    en: '{aspect} ({kind})',
    id: '{aspect} ({kind})',
    vi: '{aspect} ({kind})',
    th: '{aspect} ({kind})',
    ja: '{aspect} ({kind})',
    ko: '{aspect} ({kind})',
  },
  'studio.media.purpose': {
    'zh-TW': 'purpose', 'zh-CN': 'purpose', en: 'purpose', id: 'purpose', vi: 'purpose', th: 'purpose', ja: 'purpose', ko: 'purpose',
  },
  'studio.media.composition': {
    'zh-TW': 'composition', 'zh-CN': 'composition', en: 'composition', id: 'composition', vi: 'composition', th: 'composition', ja: 'composition', ko: 'composition',
  },
  'studio.media.forbidden': {
    'zh-TW': 'forbidden', 'zh-CN': 'forbidden', en: 'forbidden', id: 'forbidden', vi: 'forbidden', th: 'forbidden', ja: 'forbidden', ko: 'forbidden',
  },
  'studio.media.alt': {
    'zh-TW': 'alt', 'zh-CN': 'alt', en: 'alt', id: 'alt', vi: 'alt', th: 'alt', ja: 'alt', ko: 'alt',
  },
  'studio.media.remove': {
    'zh-TW': '移除 slot', 'zh-CN': '移除 slot', en: 'Remove slot', id: 'Hapus slot', vi: 'Xoá slot', th: 'ลบ slot', ja: 'slot を削除', ko: '슬롯 제거',
  },
  'studio.media.add': {
    'zh-TW': '新增 slot', 'zh-CN': '新增 slot', en: 'Add slot', id: 'Tambah slot', vi: 'Thêm slot', th: 'เพิ่ม slot', ja: 'slot を追加', ko: '슬롯 추가',
  },
  'studio.media.write': {
    'zh-TW': '寫入 markdown',
    'zh-CN': '写入 markdown',
    en: 'Write to markdown',
    id: 'Tulis ke markdown',
    vi: 'Ghi vào markdown',
    th: 'เขียนลง markdown',
    ja: 'markdown に書き込む',
    ko: 'markdown에 쓰기',
  },
  'studio.media.issues': {
    'zh-TW': '驗證清單中有 {count} 筆 Media 問題。',
    'zh-CN': '验证清单中有 {count} 笔 Media 问题。',
    en: '{count} Media issue(s) in Validation list.',
    id: '{count} isu Media di daftar Validasi.',
    vi: '{count} vấn đề Media trong danh sách Validation.',
    th: 'มีปัญหา Media {count} รายการในรายการ Validation',
    ja: '検証リストに Media 問題が {count} 件あります。',
    ko: '검증 목록에 Media 이슈 {count}개.',
  },
  'studio.rwd.allComplete': {
    'zh-TW': '全部完成', 'zh-CN': '全部完成', en: 'All complete', id: 'Semua lengkap', vi: 'Tất cả đủ', th: 'ครบทั้งหมด', ja: 'すべて完了', ko: '모두 완료',
  },
  'studio.rwd.hint': {
    'zh-TW': '可只填寬度。若任一個 columns／stack／table 有值，三個 breakpoint 都要填齊，否則驗證會拒絕。',
    'zh-CN': '可只填宽度。若任一个 columns／stack／table 有值，三个 breakpoint 都要填齐，否则验证会拒绝。',
    en: 'Width-only is allowed. If any columns／stack／table is set, fill all three breakpoints or validation will refuse.',
    id: 'Hanya width diperbolehkan. Jika columns／stack／table ada yang diisi, isi ketiga breakpoint atau validasi menolak.',
    vi: 'Chỉ width cũng được. Nếu có columns／stack／table, phải điền đủ ba breakpoint hoặc validation sẽ từ chối.',
    th: 'ใส่เฉพาะความกว้างได้ ถ้ามี columns／stack／table ต้องกรอกครบสาม breakpoint ไม่งั้น validation จะปฏิเสธ',
    ja: '幅のみ可。columns／stack／table のいずれかを設定したら 3 つの breakpoint を埋めること。未完了は検証拒否。',
    ko: '너비만 허용. columns／stack／table 중 하나라도 있으면 세 breakpoint를 모두 채우세요. 아니면 검증이 거부합니다.',
  },
  'studio.rwd.breakpoint': {
    'zh-TW': 'Breakpoint', 'zh-CN': 'Breakpoint', en: 'Breakpoint', id: 'Breakpoint', vi: 'Breakpoint', th: 'Breakpoint', ja: 'Breakpoint', ko: 'Breakpoint',
  },
  'studio.rwd.width': {
    'zh-TW': '寬度', 'zh-CN': '宽度', en: 'Width', id: 'Lebar', vi: 'Chiều rộng', th: 'ความกว้าง', ja: '幅', ko: '너비',
  },
  'studio.rwd.columns': {
    'zh-TW': '欄數', 'zh-CN': '栏数', en: 'Columns', id: 'Kolom', vi: 'Cột', th: 'คอลัมน์', ja: '列数', ko: '열 수',
  },
  'studio.rwd.stack': {
    'zh-TW': '堆疊', 'zh-CN': '堆叠', en: 'Stack', id: 'Stack', vi: 'Stack', th: 'Stack', ja: 'スタック', ko: '스택',
  },
  'studio.rwd.table': {
    'zh-TW': '表格', 'zh-CN': '表格', en: 'Table', id: 'Tabel', vi: 'Bảng', th: 'ตาราง', ja: 'テーブル', ko: '테이블',
  },
  'studio.rwd.complete': {
    'zh-TW': '完成', 'zh-CN': '完成', en: 'Complete', id: 'Lengkap', vi: 'Đủ', th: 'ครบ', ja: '完了', ko: '완료',
  },
  'studio.rwd.write': {
    'zh-TW': '寫入 markdown',
    'zh-CN': '写入 markdown',
    en: 'Write to markdown',
    id: 'Tulis ke markdown',
    vi: 'Ghi vào markdown',
    th: 'เขียนลง markdown',
    ja: 'markdown に書き込む',
    ko: 'markdown에 쓰기',
  },
  'studio.rwd.issues': {
    'zh-TW': '驗證清單中有 {count} 筆 RWD 問題。',
    'zh-CN': '验证清单中有 {count} 笔 RWD 问题。',
    en: '{count} RWD issue(s) in Validation list.',
    id: '{count} isu RWD di daftar Validasi.',
    vi: '{count} vấn đề RWD trong danh sách Validation.',
    th: 'มีปัญหา RWD {count} รายการในรายการ Validation',
    ja: '検証リストに RWD 問題が {count} 件あります。',
    ko: '검증 목록에 RWD 이슈 {count}개.',
  },
  'studio.section.hint': {
    'zh-TW': '在 # Sections 下寫入 component／layout.type＋layout params／content／style（純量或如 cta.label 的點路徑巢狀）／media／bind.source。兩層以上巢狀仍只在 Markdown。',
    'zh-CN': '在 # Sections 下写入 component／layout.type＋layout params／content／style（标量或如 cta.label 的点路径嵌套）／media／bind.source。两层以上嵌套仍只在 Markdown。',
    en: 'Write component／layout.type＋layout params／content／style（scalar or dotted nested like cta.label）／media／bind.source under # Sections. Two-or-more-level nesting stays Markdown-only.',
    id: 'Tulis component／layout.type＋layout params／content／style（skalar atau nested bertitik seperti cta.label）／media／bind.source di # Sections. Nesting ≥2 level tetap Markdown saja.',
    vi: 'Ghi component／layout.type＋layout params／content／style（scalar hoặc lồng chấm như cta.label）／media／bind.source dưới # Sections. Lồng ≥2 tầng chỉ trong Markdown.',
    th: 'เขียน component／layout.type＋layout params／content／style（สเกลาร์หรือซ้อนจุดเช่น cta.label）／media／bind.source ใต้ # Sections การซ้อน ≥2 ระดับยังอยู่ใน Markdown เท่านั้น',
    ja: '# Sections に component／layout.type＋layout params／content／style（スカラーまたは cta.label のような点ネスト）／media／bind.source を書く。2 階層以上は Markdown のみ。',
    ko: '# Sections 아래에 component／layout.type＋layout params／content／style（스칼라 또는 cta.label 같은 점 중첩）／media／bind.source를 씁니다. 2단계 이상 중첩은 Markdown만.',
  },
  'studio.section.id': {
    'zh-TW': 'Id', 'zh-CN': 'Id', en: 'Id', id: 'Id', vi: 'Id', th: 'Id', ja: 'Id', ko: 'Id',
  },
  'studio.section.component': {
    'zh-TW': '元件', 'zh-CN': '组件', en: 'Component', id: 'Komponen', vi: 'Component', th: 'คอมโพเนนต์', ja: 'コンポーネント', ko: '컴포넌트',
  },
  'studio.section.layoutType': {
    'zh-TW': '版型類型', 'zh-CN': '版型类型', en: 'Layout type', id: 'Tipe layout', vi: 'Loại layout', th: 'ชนิดเลย์เอาต์', ja: 'レイアウト種別', ko: '레이아웃 유형',
  },
  'studio.section.layoutParams': {
    'zh-TW': 'Layout params（每行 key: value）',
    'zh-CN': 'Layout params（每行 key: value）',
    en: 'Layout params (key: value per line)',
    id: 'Layout params (key: value per baris)',
    vi: 'Layout params (key: value mỗi dòng)',
    th: 'Layout params (key: value ต่อบรรทัด)',
    ja: 'Layout params（行ごと key: value）',
    ko: 'Layout params(줄마다 key: value)',
  },
  'studio.section.bindSource': {
    'zh-TW': 'Bind source', 'zh-CN': 'Bind source', en: 'Bind source', id: 'Bind source', vi: 'Bind source', th: 'Bind source', ja: 'Bind source', ko: 'Bind source',
  },
  'studio.section.mediaSlots': {
    'zh-TW': 'Media slots（逗號分隔）',
    'zh-CN': 'Media slots（逗号分隔）',
    en: 'Media slots (comma-separated)',
    id: 'Media slots (dipisah koma)',
    vi: 'Media slots (cách bằng dấu phẩy)',
    th: 'Media slots (คั่นด้วยจุลภาค)',
    ja: 'Media slots（カンマ区切り）',
    ko: 'Media slots(쉼표 구분)',
  },
  'studio.section.content': {
    'zh-TW': 'Content（每行 key: value；巢狀用 cta.label）',
    'zh-CN': 'Content（每行 key: value；嵌套用 cta.label）',
    en: 'Content (key: value per line; use cta.label for nesting)',
    id: 'Content (key: value per baris; gunakan cta.label untuk nesting)',
    vi: 'Content (key: value mỗi dòng; dùng cta.label để lồng)',
    th: 'Content (key: value ต่อบรรทัด; ใช้ cta.label สำหรับการซ้อน)',
    ja: 'Content（行ごと key: value；ネストは cta.label）',
    ko: 'Content(줄마다 key: value; 중첩은 cta.label)',
  },
  'studio.section.style': {
    'zh-TW': 'Style（每行 key: value；巢狀用 theme.tone）',
    'zh-CN': 'Style（每行 key: value；嵌套用 theme.tone）',
    en: 'Style (key: value per line; use theme.tone for nesting)',
    id: 'Style (key: value per baris; gunakan theme.tone untuk nesting)',
    vi: 'Style (key: value mỗi dòng; dùng theme.tone để lồng)',
    th: 'Style (key: value ต่อบรรทัด; ใช้ theme.tone สำหรับการซ้อน)',
    ja: 'Style（行ごと key: value；ネストは theme.tone）',
    ko: 'Style(줄마다 key: value; 중첩은 theme.tone)',
  },
  'studio.section.remove': {
    'zh-TW': '移除', 'zh-CN': '移除', en: 'Remove', id: 'Hapus', vi: 'Xoá', th: 'ลบ', ja: '削除', ko: '제거',
  },
  'studio.section.add': {
    'zh-TW': '新增 section', 'zh-CN': '新增 section', en: 'Add section', id: 'Tambah section', vi: 'Thêm section', th: 'เพิ่ม section', ja: 'section を追加', ko: '섹션 추가',
  },
  'studio.section.write': {
    'zh-TW': '寫入 sections 到 markdown',
    'zh-CN': '写入 sections 到 markdown',
    en: 'Write sections to markdown',
    id: 'Tulis sections ke markdown',
    vi: 'Ghi sections vào markdown',
    th: 'เขียน sections ลง markdown',
    ja: 'sections を markdown に書き込む',
    ko: 'sections를 markdown에 쓰기',
  },
  'studio.section.componentShort': {
    'zh-TW': 'component', 'zh-CN': 'component', en: 'component', id: 'component', vi: 'component', th: 'component', ja: 'component', ko: 'component',
  },
  'studio.section.layoutShort': {
    'zh-TW': 'layout', 'zh-CN': 'layout', en: 'layout', id: 'layout', vi: 'layout', th: 'layout', ja: 'layout', ko: 'layout',
  },
  'studio.section.bindShort': {
    'zh-TW': 'bind', 'zh-CN': 'bind', en: 'bind', id: 'bind', vi: 'bind', th: 'bind', ja: 'bind', ko: 'bind',
  },
  'studio.section.contentKeys': {
    'zh-TW': 'content keys', 'zh-CN': 'content keys', en: 'content keys', id: 'content keys', vi: 'content keys', th: 'content keys', ja: 'content keys', ko: 'content keys',
  },
  'studio.section.styleKeys': {
    'zh-TW': 'style keys', 'zh-CN': 'style keys', en: 'style keys', id: 'style keys', vi: 'style keys', th: 'style keys', ja: 'style keys', ko: 'style keys',
  },
  'studio.section.mediaShort': {
    'zh-TW': 'media', 'zh-CN': 'media', en: 'media', id: 'media', vi: 'media', th: 'media', ja: 'media', ko: 'media',
  },
  'studio.section.issues': {
    'zh-TW': '驗證清單中有 {count} 筆 Section 問題。',
    'zh-CN': '验证清单中有 {count} 笔 Section 问题。',
    en: '{count} Section issue(s) in Validation list.',
    id: '{count} isu Section di daftar Validasi.',
    vi: '{count} vấn đề Section trong danh sách Validation.',
    th: 'มีปัญหา Section {count} รายการในรายการ Validation',
    ja: '検証リストに Section 問題が {count} 件あります。',
    ko: '검증 목록에 Section 이슈 {count}개.',
  },
  'studio.caps.hint': {
    'zh-TW': 'cart／payment／members 需明確 PARTIAL degrade 確認（§89）。允許清單為封閉詞彙。Commerce refuse 路徑也落在此——currency 屬於 # Commerce（§111.1）。',
    'zh-CN': 'cart／payment／members 需明确 PARTIAL degrade 确认（§89）。允许清单为封闭词汇。Commerce refuse 路径也落在此——currency 属于 # Commerce（§111.1）。',
    en: 'Explicit PARTIAL degrade confirmation for cart／payment／members (§89). Allowed lists are the closed vocabularies. Commerce refuse paths also land here — currency belongs in # Commerce (§111.1).',
    id: 'Konfirmasi PARTIAL degrade eksplisit untuk cart／payment／members (§89). Daftar allowed adalah kosakata tertutup. Jalur refuse Commerce juga di sini — currency ada di # Commerce (§111.1).',
    vi: 'Xác nhận PARTIAL degrade rõ ràng cho cart／payment／members (§89). Danh sách allowed là từ vựng đóng. Đường refuse Commerce cũng ở đây — currency thuộc # Commerce (§111.1).',
    th: 'ยืนยัน PARTIAL degrade ชัดเจนสำหรับ cart／payment／members (§89) รายการที่อนุญาตเป็นศัพท์ปิด เส้นทาง refuse ของ Commerce ก็อยู่ที่นี่ — currency อยู่ใน # Commerce (§111.1)',
    ja: 'cart／payment／members の PARTIAL degrade は明示確認（§89）。許可リストは閉じた語彙。Commerce refuse もここ — currency は # Commerce（§111.1）。',
    ko: 'cart／payment／members의 PARTIAL degrade는 명시 확인(§89). 허용 목록은 닫힌 어휘. Commerce refuse 경로도 여기 — currency는 # Commerce(§111.1).',
  },
  'studio.caps.cart': {
    'zh-TW': '購物車', 'zh-CN': '购物车', en: 'Cart', id: 'Keranjang', vi: 'Giỏ', th: 'ตะกร้า', ja: 'カート', ko: '장바구니',
  },
  'studio.caps.payment': {
    'zh-TW': '付款', 'zh-CN': '付款', en: 'Payment', id: 'Pembayaran', vi: 'Thanh toán', th: 'การชำระเงิน', ja: '支払い', ko: '결제',
  },
  'studio.caps.members': {
    'zh-TW': '會員', 'zh-CN': '会员', en: 'Members', id: 'Anggota', vi: 'Thành viên', th: 'สมาชิก', ja: '会員', ko: '회원',
  },
  'studio.caps.confirmed': {
    'zh-TW': '已確認', 'zh-CN': '已确认', en: 'confirmed', id: 'terkonfirmasi', vi: 'đã xác nhận', th: 'ยืนยันแล้ว', ja: '確認済み', ko: '확인됨',
  },
  'studio.caps.writeCapabilities': {
    'zh-TW': '寫入 Capabilities 到 markdown',
    'zh-CN': '写入 Capabilities 到 markdown',
    en: 'Write Capabilities to markdown',
    id: 'Tulis Capabilities ke markdown',
    vi: 'Ghi Capabilities vào markdown',
    th: 'เขียน Capabilities ลง markdown',
    ja: 'Capabilities を markdown に書き込む',
    ko: 'Capabilities를 markdown에 쓰기',
  },
  'studio.caps.commerce': {
    'zh-TW': 'Commerce', 'zh-CN': 'Commerce', en: 'Commerce', id: 'Commerce', vi: 'Commerce', th: 'Commerce', ja: 'Commerce', ko: 'Commerce',
  },
  'studio.caps.currency': {
    'zh-TW': '幣別', 'zh-CN': '币别', en: 'Currency', id: 'Mata uang', vi: 'Tiền tệ', th: 'สกุลเงิน', ja: '通貨', ko: '통화',
  },
  'studio.caps.checkout': {
    'zh-TW': '結帳', 'zh-CN': '结账', en: 'Checkout', id: 'Checkout', vi: 'Checkout', th: 'Checkout', ja: 'チェックアウト', ko: '체크아웃',
  },
  'studio.caps.orderLookup': {
    'zh-TW': '訂單查詢', 'zh-CN': '订单查询', en: 'Order lookup', id: 'Lookup pesanan', vi: 'Tra cứu đơn', th: 'ค้นหาคำสั่งซื้อ', ja: '注文照会', ko: '주문 조회',
  },
  'studio.caps.commercePayment': {
    'zh-TW': 'Commerce 付款', 'zh-CN': 'Commerce 付款', en: 'Commerce payment', id: 'Pembayaran Commerce', vi: 'Thanh toán Commerce', th: 'การชำระเงิน Commerce', ja: 'Commerce 支払い', ko: 'Commerce 결제',
  },
  'studio.caps.writeCommerce': {
    'zh-TW': '寫入 Commerce 到 markdown',
    'zh-CN': '写入 Commerce 到 markdown',
    en: 'Write Commerce to markdown',
    id: 'Tulis Commerce ke markdown',
    vi: 'Ghi Commerce vào markdown',
    th: 'เขียน Commerce ลง markdown',
    ja: 'Commerce を markdown に書き込む',
    ko: 'Commerce를 markdown에 쓰기',
  },
  'studio.caps.cartConfirmed': {
    'zh-TW': 'Cart 已確認', 'zh-CN': 'Cart 已确认', en: 'Cart confirmed', id: 'Cart terkonfirmasi', vi: 'Cart đã xác nhận', th: 'Cart ยืนยันแล้ว', ja: 'Cart 確認済み', ko: 'Cart 확인됨',
  },
  'studio.caps.paymentConfirmed': {
    'zh-TW': 'Payment 已確認', 'zh-CN': 'Payment 已确认', en: 'Payment confirmed', id: 'Payment terkonfirmasi', vi: 'Payment đã xác nhận', th: 'Payment ยืนยันแล้ว', ja: 'Payment 確認済み', ko: 'Payment 확인됨',
  },
  'studio.caps.membersConfirmed': {
    'zh-TW': 'Members 已確認', 'zh-CN': 'Members 已确认', en: 'Members confirmed', id: 'Members terkonfirmasi', vi: 'Members đã xác nhận', th: 'Members ยืนยันแล้ว', ja: 'Members 確認済み', ko: 'Members 확인됨',
  },
  'studio.caps.vocab': {
    'zh-TW': '詞彙', 'zh-CN': '词汇', en: 'vocab', id: 'kosakata', vi: 'từ vựng', th: 'คำศัพท์', ja: '語彙', ko: '어휘',
  },
  'studio.caps.allowed': {
    'zh-TW': '允許', 'zh-CN': '允许', en: 'allowed', id: 'diizinkan', vi: 'được phép', th: 'อนุญาต', ja: '許可', ko: '허용',
  },
  'studio.caps.issues': {
    'zh-TW': '驗證清單中有 {count} 筆 Capabilities 問題。',
    'zh-CN': '验证清单中有 {count} 笔 Capabilities 问题。',
    en: '{count} Capabilities issue(s) in Validation list.',
    id: '{count} isu Capabilities di daftar Validasi.',
    vi: '{count} vấn đề Capabilities trong danh sách Validation.',
    th: 'มีปัญหา Capabilities {count} รายการในรายการ Validation',
    ja: '検証リストに Capabilities 問題が {count} 件あります。',
    ko: '검증 목록에 Capabilities 이슈 {count}개.',
  },
  'studio.markdownLabel': {
    'zh-TW': '網站需求規格（mybo.site.v1 Markdown）',
    'zh-CN': '网站需求规格（mybo.site.v1 Markdown）',
    en: 'Website specification (mybo.site.v1 Markdown)',
    id: 'Skill markdown (mybo.site.v1)',
    vi: 'Skill markdown (mybo.site.v1)',
    th: 'Skill markdown (mybo.site.v1)',
    ja: 'Skill markdown（mybo.site.v1）',
    ko: 'Skill markdown(mybo.site.v1)',
  },
  'studio.markdownSource': {
    'zh-TW': '原始碼',
    'zh-CN': '源代码',
    en: 'Source',
    id: 'Sumber',
    vi: 'Mã nguồn',
    th: 'ต้นฉบับ',
    ja: 'ソース',
    ko: '소스',
  },
  'studio.markdownPreview': {
    'zh-TW': '預覽',
    'zh-CN': '预览',
    en: 'Preview',
    id: 'Pratinjau',
    vi: 'Xem trước',
    th: 'ดูตัวอย่าง',
    ja: 'プレビュー',
    ko: '미리보기',
  },
  'studio.markdownViewAria': {
    'zh-TW': 'Markdown 檢視',
    'zh-CN': 'Markdown 视图',
    en: 'Markdown view',
    id: 'Tampilan Markdown',
    vi: 'Chế độ xem Markdown',
    th: 'มุมมอง Markdown',
    ja: 'Markdown 表示',
    ko: 'Markdown 보기',
  },
  'studio.themePromptMissing': {
    'zh-TW': '主題 Prompt markdown 缺失。',
    'zh-CN': '主题 Prompt markdown 缺失。',
    en: 'Theme prompt markdown is missing.',
    id: 'Markdown prompt tema tidak ada.',
    vi: 'Thiếu markdown prompt của theme.',
    th: 'ไม่มี markdown ของ theme prompt',
    ja: 'テーマの Prompt markdown がありません。',
    ko: '테마 Prompt markdown이 없습니다.',
  },
  'studio.loadFailed': {
    'zh-TW': '載入失敗：{message}',
    'zh-CN': '加载失败：{message}',
    en: 'Load failed: {message}',
    id: 'Gagal memuat: {message}',
    vi: 'Tải thất bại: {message}',
    th: 'โหลดไม่สำเร็จ: {message}',
    ja: '読み込み失敗：{message}',
    ko: '로드 실패: {message}',
  },
  'studio.validationTitle': {
    'zh-TW': '驗證', 'zh-CN': '验证', en: 'Validation', id: 'Validasi', vi: 'Xác thực', th: 'การตรวจสอบ', ja: '検証', ko: '검증',
  },
  'studio.validationAria': {
    'zh-TW': '驗證問題', 'zh-CN': '验证问题', en: 'Validation issues', id: 'Masalah validasi', vi: 'Vấn đề xác thực', th: 'รายการปัญหา', ja: '検証の問題', ko: '검증 이슈',
  },
  'studio.validationPass': {
    'zh-TW': '草稿通過 refuse 門檻。',
    'zh-CN': '草稿通过 refuse 门槛。',
    en: 'Draft passes refuse gates.',
    id: 'Draft lolos gerbang refuse.',
    vi: 'Bản nháp vượt qua refuse gates.',
    th: 'ฉบับร่างผ่าน refuse gates',
    ja: '下書きは refuse ゲートを通過しています。',
    ko: '초안이 refuse 게이트를 통과했습니다.',
  },
  'studio.validationRefuse': {
    'zh-TW': '拒絕 · 階段',
    'zh-CN': '拒绝 · 阶段',
    en: 'Refuse · stage',
    id: 'Refuse · tahap',
    vi: 'Refuse · giai đoạn',
    th: 'Refuse · ขั้น',
    ja: '拒否 · 段階',
    ko: '거부 · 단계',
  },
  'studio.validationNeedRun': {
    'zh-TW': '請先執行「驗證並投影」以載入問題。',
    'zh-CN': '请先执行「验证并投影」以载入问题。',
    en: 'Run Validate & project to populate issues.',
    id: 'Jalankan Validate & project untuk mengisi isu.',
    vi: 'Chạy Validate & project để tải vấn đề.',
    th: 'รัน Validate & project เพื่อโหลดปัญหา',
    ja: 'Validate & project を実行して問題を読み込んでください。',
    ko: 'Validate & project를 실행해 이슈를 불러오세요.',
  },
  'studio.validationEmpty': {
    'zh-TW': '沒有 refuse 問題。',
    'zh-CN': '没有 refuse 问题。',
    en: 'No refuse issues.',
    id: 'Tidak ada isu refuse.',
    vi: 'Không có vấn đề refuse.',
    th: 'ไม่มีปัญหา refuse',
    ja: 'refuse の問題はありません。',
    ko: 'refuse 이슈가 없습니다.',
  },
  'studio.validationJump': {
    'zh-TW': '跳到面板', 'zh-CN': '跳到面板', en: 'Jump to panel', id: 'Lompat ke panel', vi: 'Nhảy tới panel', th: 'ไปที่แผง', ja: 'パネルへ移動', ko: '패널로 이동',
  },
  'studio.acceptanceTitle': {
    'zh-TW': '驗收', 'zh-CN': '验收', en: 'Acceptance', id: 'Acceptance', vi: 'Acceptance', th: 'Acceptance', ja: 'Acceptance', ko: 'Acceptance',
  },
  'studio.acceptanceAria': {
    'zh-TW': '驗收清單', 'zh-CN': '验收清单', en: 'Acceptance checklist', id: 'Daftar acceptance', vi: 'Danh sách acceptance', th: 'เช็คลิสต์ Acceptance', ja: 'Acceptance チェックリスト', ko: 'Acceptance 체크리스트',
  },
  'studio.acceptanceMeta': {
    'zh-TW': '在 <code># Acceptance</code> 寫檢查項（至少 {min} 項）· {count} 項',
    'zh-CN': '在 <code># Acceptance</code> 写检查项（至少 {min} 项）· {count} 项',
    en: 'Write checklist bullets under <code># Acceptance</code> (need ≥ {min}). · {count} item(s)',
    id: 'Tulis checklist di <code># Acceptance</code> (perlu ≥ {min}). · {count} item',
    vi: 'Viết checklist dưới <code># Acceptance</code> (cần ≥ {min}). · {count} mục',
    th: 'เขียนเช็คลิสต์ใต้ <code># Acceptance</code> (อย่างน้อย {min}) · {count} รายการ',
    ja: '<code># Acceptance</code> にチェック項目を書いてください（≥ {min}）。· {count} 件',
    ko: '<code># Acceptance</code>에 체크리스트를 작성하세요(≥ {min}). · {count}개',
  },
  'studio.acceptanceRemove': {
    'zh-TW': '移除', 'zh-CN': '移除', en: 'Remove', id: 'Hapus', vi: 'Xóa', th: 'ลบ', ja: '削除', ko: '제거',
  },
  'studio.acceptanceAdd': {
    'zh-TW': '新增項目', 'zh-CN': '新增项目', en: 'Add item', id: 'Tambah item', vi: 'Thêm mục', th: 'เพิ่มรายการ', ja: '項目を追加', ko: '항목 추가',
  },
  'studio.acceptanceApply': {
    'zh-TW': '寫入 Acceptance 到 markdown',
    'zh-CN': '写入 Acceptance 到 markdown',
    en: 'Write acceptance to markdown',
    id: 'Tulis acceptance ke markdown',
    vi: 'Ghi acceptance vào markdown',
    th: 'เขียน acceptance ลง markdown',
    ja: 'Acceptance を markdown に書き込む',
    ko: 'Acceptance를 markdown에 쓰기',
  },
  'examples.promptTitle': {
    'zh-TW': '設計 Prompt', 'zh-CN': '设计 Prompt', en: 'Design prompt', id: 'Prompt desain', vi: 'Prompt thiết kế', th: 'Design prompt', ja: 'デザイン Prompt', ko: '디자인 Prompt',
  },
  'examples.promptClose': {
    'zh-TW': '關閉', 'zh-CN': '关闭', en: 'Close', id: 'Tutup', vi: 'Đóng', th: 'ปิด', ja: '閉じる', ko: '닫기',
  },
  'examples.promptCopy': {
    'zh-TW': '複製全部', 'zh-CN': '复制全部', en: 'Copy all', id: 'Salin semua', vi: 'Sao chép tất cả', th: 'คัดลอกทั้งหมด', ja: 'すべてコピー', ko: '전체 복사',
  },
  'examples.promptLoading': {
    'zh-TW': '載入 Prompt…', 'zh-CN': '加载 Prompt…', en: 'Loading prompt…', id: 'Memuat prompt…', vi: 'Đang tải prompt…', th: 'กำลังโหลด…', ja: '読込中…', ko: '불러오는 중…',
  },
  'examples.promptMissing': {
    'zh-TW': '此主題尚無 Prompt。', 'zh-CN': '此主题尚无 Prompt。', en: 'No prompt for this theme.', id: 'Belum ada prompt.', vi: 'Chưa có prompt.', th: 'ยังไม่มี prompt', ja: 'Prompt がありません。', ko: 'Prompt가 없습니다.',
  },
  'examples.prev': {
    'zh-TW': '上一頁', 'zh-CN': '上一页', en: 'Prev', id: 'Sebelumnya', vi: 'Trước', th: 'ก่อนหน้า', ja: '前へ', ko: '이전',
  },
  'examples.next': {
    'zh-TW': '下一頁', 'zh-CN': '下一页', en: 'Next', id: 'Berikutnya', vi: 'Sau', th: 'ถัดไป', ja: '次へ', ko: '다음',
  },
  'examples.showing': {
    'zh-TW': '顯示', 'zh-CN': '显示', en: 'Showing', id: 'Menampilkan', vi: 'Đang xem', th: 'แสดง', ja: '表示', ko: '표시',
  },
  'examples.loading': {
    'zh-TW': '正在載入真實站點…', 'zh-CN': '正在加载真实站点…', en: 'Loading live demos…', id: 'Memuat demo live…', vi: 'Đang tải demo…', th: 'กำลังโหลด…', ja: '読込中…', ko: '불러오는 중…',
  },
  'examples.loadFailed': {
    'zh-TW': '載入失敗', 'zh-CN': '加载失败', en: 'Load failed', id: 'Gagal memuat', vi: 'Tải thất bại', th: 'โหลดไม่สำเร็จ', ja: '読込失敗', ko: '로드 실패',
  },
  'examples.liveStatus': {
    'zh-TW': '已上線站點', 'zh-CN': '已上线站点', en: 'Live sites', id: 'Situs live', vi: 'Site đang live', th: 'ไซต์ที่เปิดแล้ว', ja: '稼働中', ko: '라이브 사이트',
  },
  'examples.live': {
    'zh-TW': '已上線', 'zh-CN': '已上线', en: 'Live', id: 'Live', vi: 'Live', th: 'เปิดแล้ว', ja: '稼働', ko: '라이브',
  },
  'examples.offline': {
    'zh-TW': '未建立', 'zh-CN': '未建立', en: 'Missing', id: 'Belum ada', vi: 'Chưa có', th: 'ยังไม่มี', ja: '未作成', ko: '미생성',
  },
  'examples.products': {
    'zh-TW': '商品數', 'zh-CN': '商品数', en: 'Products', id: 'Produk', vi: 'Sản phẩm', th: 'สินค้า', ja: '商品数', ko: '상품 수',
  },
  'nav.ctaFree': {
    'zh-TW': '免費開始', 'zh-CN': '免费开始', en: 'Start free', id: 'Mulai gratis', vi: 'Bắt đầu miễn phí', th: 'เริ่มฟรี', ja: '無料で始める', ko: '무료 시작',
  },
  'hero.titleLine1': {
    'zh-TW': '快速建站', 'zh-CN': '快速建站', en: 'Launch fast', id: 'Bangun cepat', vi: 'Dựng site nhanh', th: 'สร้างเว็บเร็ว', ja: 'すばやく開設', ko: '빠른 개설',
  },
  'hero.titleLine2': {
    'zh-TW': '輕鬆管理', 'zh-CN': '轻松管理', en: 'Manage easily', id: 'Kelola mudah', vi: 'Quản lý dễ', th: 'จัดการง่าย', ja: 'かんたん管理', ko: '쉬운 관리',
  },
  'hero.ctaFeatures': {
    'zh-TW': '查看功能', 'zh-CN': '查看功能', en: 'See features', id: 'Lihat fitur', vi: 'Xem tính năng', th: 'ดูฟีเจอร์', ja: '機能を見る', ko: '기능 보기',
  },
  'home.coreLabel': {
    'zh-TW': '核心功能', 'zh-CN': '核心功能', en: 'Core', id: 'Inti', vi: 'Cốt lõi', th: 'แกนหลัก', ja: 'コア', ko: '핵심',
  },
  'home.coreTitle': {
    'zh-TW': '一個平台，完整解決方案', 'zh-CN': '一个平台，完整解决方案', en: 'One platform, full toolkit', id: 'Satu platform, solusi lengkap', vi: 'Một nền tảng, giải pháp đầy đủ', th: 'หนึ่งแพลตฟอร์ม ครบวงจร', ja: 'ひとつのプラットフォームで完結', ko: '하나의 플랫폼, 완전한 솔루션',
  },
  'home.coreSub': {
    'zh-TW': '從建站到上線，每個環節都有完整工具支援', 'zh-CN': '从建站到上线，每个环节都有完整工具支持', en: 'From launch to go-live, every step is covered', id: 'Dari bangun hingga live, semua tercover', vi: 'Từ dựng site đến lên sóng đều có công cụ', th: 'ตั้งแต่สร้างถึงขึ้นจริงครบทุกขั้น', ja: '開設から公開まで各工程を支援', ko: '개설부터 오픈까지 전 과정 지원',
  },
  'feat.domain.title': { 'zh-TW': '網域與 SSL', 'zh-CN': '域名与 SSL', en: 'Domain & SSL', id: 'Domain & SSL', vi: 'Domain & SSL', th: 'โดเมน & SSL', ja: 'ドメインとSSL', ko: '도메인 & SSL' },
  'feat.domain.desc': {
    'zh-TW': '免費子網域，支援自訂網域加購。SSL 自動申請與更新。',
    'zh-CN': '免费子域名，支持自定义域名加购。SSL 自动申请与更新。',
    en: 'Free subdomain plus custom domain add-on. Auto SSL.',
    id: 'Subdomain gratis + domain kustom. SSL otomatis.',
    vi: 'Subdomain miễn phí, domain tùy chỉnh. SSL tự động.',
    th: 'ซับโดเมนฟรี โดเมนกำหนดเอง SSL อัตโนมัติ',
    ja: '無料サブドメイン、独自ドメイン追加、SSL自動。',
    ko: '무료 서브도메인, 커스텀 도메인 추가, SSL 자동.',
  },
  'feat.theme.title': { 'zh-TW': '主題與模組', 'zh-CN': '主题与模块', en: 'Themes & modules', id: 'Tema & modul', vi: 'Theme & module', th: 'ธีมและโมดูล', ja: 'テーマとモジュール', ko: '테마와 모듈' },
  'feat.theme.desc': {
    'zh-TW': '專業主題與電商／部落格等模組，一鍵啟用。',
    'zh-CN': '专业主题与电商／博客等模块，一键启用。',
    en: 'Professional themes and commerce/blog modules, one-click enable.',
    id: 'Tema profesional dan modul commerce/blog, aktifkan sekali klik.',
    vi: 'Theme chuyên nghiệp và module thương mại/blog, bật một chạm.',
    th: 'ธีมมืออาชีพและโมดูลร้านค้า/บล็อก เปิดใช้คลิกเดียว',
    ja: 'プロ向けテーマとEC／ブログ等モジュールをワンクリック。',
    ko: '프로 테마와 커머스/블로그 모듈을 원클릭 활성화.',
  },
  'feat.multisite.title': { 'zh-TW': '多站管理', 'zh-CN': '多站管理', en: 'Multi-site', id: 'Multi-situs', vi: 'Đa site', th: 'หลายไซต์', ja: 'マルチサイト', ko: '다중 사이트' },
  'feat.multisite.desc': {
    'zh-TW': '一帳號管理多個網站，統一切換與資源配置。',
    'zh-CN': '一账号管理多个网站，统一切换与资源配置。',
    en: 'One account manages many sites with clear switching.',
    id: 'Satu akun kelola banyak situs dengan peralihan jelas.',
    vi: 'Một tài khoản quản nhiều site, chuyển đổi rõ ràng.',
    th: 'บัญชีเดียวจัดการหลายเว็บ สลับชัดเจน',
    ja: '1アカウントで複数サイトを統一管理。',
    ko: '계정 하나로 여러 사이트를 통합 관리.',
  },
  'feat.pay.title': { 'zh-TW': '商家金流', 'zh-CN': '商家支付', en: 'Merchant payments', id: 'Pembayaran merchant', vi: 'Thanh toán merchant', th: 'ชำระเงินร้านค้า', ja: '加盟店決済', ko: '가맹 결제' },
  'feat.pay.desc': {
    'zh-TW': '多種金流整合，線上收款與商品銷售一次到位。',
    'zh-CN': '多种支付整合，线上收款与商品销售一次到位。',
    en: 'Multiple payment integrations for online sales.',
    id: 'Integrasi banyak payment untuk penjualan online.',
    vi: 'Nhiều cổng thanh toán cho bán hàng online.',
    th: 'เชื่อมต่อหลายช่องทางชำระเงินสำหรับขายออนไลน์',
    ja: '複数決済を統合しオンライン販売を支援。',
    ko: '다양한 결제 연동으로 온라인 판매 지원.',
  },
  'feat.i18n.title': { 'zh-TW': '多語系支援', 'zh-CN': '多语言支持', en: 'Multilingual', id: 'Multi bahasa', vi: 'Đa ngôn ngữ', th: 'หลายภาษา', ja: '多言語', ko: '다국어' },
  'feat.i18n.desc': {
    'zh-TW': '內建 8 語系切換，拓展全球市場。',
    'zh-CN': '内置 8 语系切换，拓展全球市场。',
    en: 'Built-in 8-locale picker for global markets.',
    id: '8 bahasa bawaan untuk pasar global.',
    vi: 'Sẵn 8 ngôn ngữ cho thị trường toàn cầu.',
    th: 'มี 8 ภาษาในตัวสู่ตลาดโลก',
    ja: '8言語切替でグローバル展開。',
    ko: '8개 언어로 글로벌 확장.',
  },
  'feat.security.title': { 'zh-TW': '安全與備份', 'zh-CN': '安全与备份', en: 'Security & backup', id: 'Keamanan & backup', vi: 'Bảo mật & sao lưu', th: 'ความปลอดภัยและสำรอง', ja: 'セキュリティとバックアップ', ko: '보안과 백업' },
  'feat.security.desc': {
    'zh-TW': '獨立資料邊界、定期備份與企業級資安標準。',
    'zh-CN': '独立数据边界、定期备份与企业级安全标准。',
    en: 'Isolated data boundaries, backups, enterprise security.',
    id: 'Batas data terpisah, backup, keamanan enterprise.',
    vi: 'Phân tách dữ liệu, sao lưu, bảo mật doanh nghiệp.',
    th: 'แยกข้อมูล สำรองข้อมูล มาตรฐานองค์กร',
    ja: 'データ分離・バックアップ・企業向けセキュリティ。',
    ko: '데이터 격리, 백업, 엔터프라이즈 보안.',
  },
  'features.pageTitle': {
    'zh-TW': '完整功能一覽', 'zh-CN': '完整功能一览', en: 'Full feature set', id: 'Fitur lengkap', vi: 'Đầy đủ tính năng', th: 'ฟีเจอร์ครบ', ja: '機能一覧', ko: '전체 기능',
  },
  'features.pageSub': {
    'zh-TW': '子母站、模組、金流、物流與治理一次到位', 'zh-CN': '子母站、模块、支付、物流与治理一次到位', en: 'Parent-child sites, modules, payments, logistics & governance', id: 'Parent-child, modul, payment, logistik & governance', vi: 'Site mẹ-con, module, thanh toán, logistics & quản trị', th: 'ไซต์แม่-ลูก โมดูล ชำระเงิน โลจิสติกส์และการกำกับ', ja: '親子サイト・モジュール・決済・物流・ガバナンス', ko: '모-자 사이트, 모듈, 결제, 물류, 거버넌스',
  },
  'docs.pageTitle': { 'zh-TW': '文件中心', 'zh-CN': '文档中心', en: 'Documentation', id: 'Dokumentasi', vi: 'Tài liệu', th: 'เอกสาร', ja: 'ドキュメント', ko: '문서 센터' },
  'docs.pageSub': { 'zh-TW': '開站、網域、模組與整合指引', 'zh-CN': '开站、域名、模块与整合指引', en: 'Provisioning, domains, modules & integrations', id: 'Provisioning, domain, modul & integrasi', vi: 'Mở site, domain, module & tích hợp', th: 'เปิดไซต์ โดเมน โมดูลและการเชื่อมต่อ', ja: '開設・ドメイン・モジュール・連携', ko: '개설, 도메인, 모듈, 연동' },
  'docs.body': {
    'zh-TW': '從註冊、開子站、DNS／SSL 到商家金流 setup-guide，文件會持續與產品同步。',
    'zh-CN': '从注册、开子站、DNS／SSL 到商家支付 setup-guide，文档会持续与产品同步。',
    en: 'Docs stay in sync: register, open child sites, DNS/SSL, merchant setup-guides.',
    id: 'Dokumen sinkron: daftar, buka child site, DNS/SSL, setup-guide merchant.',
    vi: 'Tài liệu đồng bộ: đăng ký, mở site con, DNS/SSL, setup-guide.',
    th: 'เอกสารอัปเดตตามผลิตภัณฑ์: สมัคร เปิดไซต์ลูก DNS/SSL และคู่มือเชื่อมต่อ',
    ja: '登録・子サイト開設・DNS／SSL・加盟店セットアップまで同期。',
    ko: '가입, 자식 사이트 개설, DNS/SSL, 가맹 설정 가이드를 제품과 동기화합니다.',
  },
  'contact.pageTitle': { 'zh-TW': '聯絡我們', 'zh-CN': '联系我们', en: 'Contact us', id: 'Hubungi kami', vi: 'Liên hệ', th: 'ติดต่อเรา', ja: 'お問い合わせ', ko: '문의하기' },
  'contact.pageSub': { 'zh-TW': '業務與技術支援', 'zh-CN': '业务与技术支持', en: 'Sales & support', id: 'Sales & support', vi: 'Kinh doanh & hỗ trợ', th: 'ฝ่ายขายและซัพพอร์ต', ja: '営業・サポート', ko: '영업 및 지원' },
  'contact.body': {
    'zh-TW': '填寫下方表單。請先驗證 Email，通過後即可送出，我們會盡快回覆。',
    'zh-CN': '填写下方表单。请先验证 Email，通过后即可提交，我们会尽快回复。',
    en: 'Fill in the form below. Verify your email first, then submit — we will reply soon.',
    id: 'Isi formulir di bawah. Verifikasi email dulu, lalu kirim — kami akan membalas segera.',
    vi: 'Điền form bên dưới. Xác minh email trước rồi gửi — chúng tôi sẽ phản hồi sớm.',
    th: 'กรอกแบบฟอร์มด้านล่าง ยืนยันอีเมลก่อนแล้วจึงส่ง เราจะตอบกลับโดยเร็ว',
    ja: '下記フォームにご記入ください。先にメール認証のうえ送信してください。折り返しご連絡します。',
    ko: '아래 양식을 작성하세요. 이메일 인증 후 제출하면 곧 답변드리겠습니다.',
  },
  'contact.name': { 'zh-TW': '姓名', 'zh-CN': '姓名', en: 'Name', id: 'Nama', vi: 'Họ tên', th: 'ชื่อ', ja: 'お名前', ko: '이름' },
  'contact.email': { 'zh-TW': 'Email', 'zh-CN': 'Email', en: 'Email', id: 'Email', vi: 'Email', th: 'อีเมล', ja: 'メール', ko: '이메일' },
  'contact.code': { 'zh-TW': '驗證碼', 'zh-CN': '验证码', en: 'Verification code', id: 'Kode verifikasi', vi: 'Mã xác minh', th: 'รหัสยืนยัน', ja: '認証コード', ko: '인증 코드' },
  'contact.subject': { 'zh-TW': '主旨', 'zh-CN': '主题', en: 'Subject', id: 'Subjek', vi: 'Tiêu đề', th: 'หัวข้อ', ja: '件名', ko: '제목' },
  'contact.message': { 'zh-TW': '訊息', 'zh-CN': '留言', en: 'Message', id: 'Pesan', vi: 'Nội dung', th: 'ข้อความ', ja: 'メッセージ', ko: '메시지' },
  'contact.sendCode': { 'zh-TW': '寄送驗證碼', 'zh-CN': '发送验证码', en: 'Send code', id: 'Kirim kode', vi: 'Gửi mã', th: 'ส่งรหัส', ja: 'コード送信', ko: '인증코드 보내기' },
  'contact.sending': { 'zh-TW': '寄送中…', 'zh-CN': '发送中…', en: 'Sending…', id: 'Mengirim…', vi: 'Đang gửi…', th: 'กำลังส่ง…', ja: '送信中…', ko: '전송 중…' },
  'contact.resendIn': { 'zh-TW': '可重新寄送：{s} 秒', 'zh-CN': '可重新发送：{s} 秒', en: 'Resend in {s}s', id: 'Kirim ulang dalam {s}d', vi: 'Gửi lại sau {s}s', th: 'ส่งใหม่ใน {s} วินาที', ja: '再送信まで {s} 秒', ko: '{s}초 후 재전송' },
  'contact.submit': { 'zh-TW': '送出訊息', 'zh-CN': '提交留言', en: 'Send message', id: 'Kirim pesan', vi: 'Gửi tin nhắn', th: 'ส่งข้อความ', ja: '送信', ko: '보내기' },
  'contact.submitting': { 'zh-TW': '送出中…', 'zh-CN': '提交中…', en: 'Sending…', id: 'Mengirim…', vi: 'Đang gửi…', th: 'กำลังส่ง…', ja: '送信中…', ko: '전송 중…' },
  'contact.toastClose': { 'zh-TW': '關閉', 'zh-CN': '关闭', en: 'Close', id: 'Tutup', vi: 'Đóng', th: 'ปิด', ja: '閉じる', ko: '닫기' },
  'contact.codeSent': { 'zh-TW': '驗證碼已寄出，請查收信箱。', 'zh-CN': '验证码已发送，请查收邮箱。', en: 'Code sent — check your inbox.', id: 'Kode terkirim — cek inbox.', vi: 'Đã gửi mã — kiểm tra hộp thư.', th: 'ส่งรหัสแล้ว — ตรวจอีเมล', ja: 'コードを送信しました。受信箱を確認してください。', ko: '인증코드를 보냈습니다. 메일함을 확인하세요.' },
  'contact.success': { 'zh-TW': '已送出，我們會盡快回覆。', 'zh-CN': '已提交，我们会尽快回复。', en: 'Sent. We will reply soon.', id: 'Terkirim. Kami akan membalas segera.', vi: 'Đã gửi. Chúng tôi sẽ phản hồi sớm.', th: 'ส่งแล้ว เราจะตอบกลับโดยเร็ว', ja: '送信しました。折り返しご連絡します。', ko: '전송되었습니다. 곧 답변드리겠습니다.' },
  'contact.err.email': { 'zh-TW': '請輸入有效 Email', 'zh-CN': '请输入有效 Email', en: 'Enter a valid email', id: 'Masukkan email valid', vi: 'Nhập email hợp lệ', th: 'กรอกอีเมลให้ถูกต้อง', ja: '有効なメールを入力', ko: '유효한 이메일을 입력하세요' },
  'contact.err.name': { 'zh-TW': '請輸入姓名', 'zh-CN': '请输入姓名', en: 'Enter your name', id: 'Masukkan nama', vi: 'Nhập họ tên', th: 'กรอกชื่อ', ja: 'お名前を入力', ko: '이름을 입력하세요' },
  'contact.err.code': { 'zh-TW': '請先寄送並輸入驗證碼', 'zh-CN': '请先发送并输入验证码', en: 'Send and enter the verification code', id: 'Kirim dan masukkan kode', vi: 'Gửi và nhập mã xác minh', th: 'ส่งและกรอกรหัสยืนยัน', ja: 'コードを送信して入力してください', ko: '인증코드를 보내고 입력하세요' },
  'contact.err.message': { 'zh-TW': '訊息至少 10 字', 'zh-CN': '留言至少 10 字', en: 'Message needs at least 10 characters', id: 'Pesan minimal 10 karakter', vi: 'Nội dung tối thiểu 10 ký tự', th: 'ข้อความอย่างน้อย 10 ตัวอักษร', ja: 'メッセージは10文字以上', ko: '메시지는 10자 이상' },
  'contact.err.rate': { 'zh-TW': '每分鐘只能寄一次驗證信，請稍後再試', 'zh-CN': '每分钟只能发送一次验证信，请稍后再试', en: 'Only one verification email per minute', id: 'Hanya satu email verifikasi per menit', vi: 'Chỉ một email xác minh mỗi phút', th: 'ส่งอีเมลยืนยันได้นาทีละครั้ง', ja: '認証メールは1分に1回まで', ko: '인증 메일은 분당 1회만 가능합니다' },
  'product.pageTitle': { 'zh-TW': '產品定位', 'zh-CN': '产品定位', en: 'Product', id: 'Produk', vi: 'Sản phẩm', th: 'ผลิตภัณฑ์', ja: 'プロダクト', ko: '제품' },
  'product.pageSub': { 'zh-TW': '子母網站平台 mybonet', 'zh-CN': '子母网站平台 mybonet', en: 'Parent-child site platform mybonet', id: 'Platform parent-child mybonet', vi: 'Nền tảng site mẹ-con mybonet', th: 'แพลตฟอร์มไซต์แม่-ลูก mybonet', ja: '親子サイト基盤 mybonet', ko: '모-자 사이트 플랫폼 mybonet' },
  'product.body': {
    'zh-TW': '母站負責開站與平台費；子站獨立後台管理內容、模組、金流與治理。',
    'zh-CN': '母站负责开站与平台费；子站独立后台管理内容、模块、支付与治理。',
    en: 'Parent handles provisioning & platform billing; child studios own content, modules, payments & governance.',
    id: 'Parent urus provisioning & billing platform; child kelola konten, modul, payment & governance.',
    vi: 'Site mẹ lo mở site & phí nền tảng; studio con lo nội dung, module, thanh toán & quản trị.',
    th: 'ไซต์แม่ดูแลเปิดไซต์และค่าแพลตฟอร์ม ไซต์ลูกจัดการเนื้อหา โมดูล การชำระเงินและการกำกับ',
    ja: '親は開設とプラットフォーム課金、子はコンテンツ・モジュール・決済・ガバナンス。',
    ko: '모사이트는 개설과 플랫폼 요금, 자식은 콘텐츠·모듈·결제·거버넌스를 담당합니다.',
  },
  'auth.welcomeBack': { 'zh-TW': '歡迎回來', 'zh-CN': '欢迎回来', en: 'Welcome back', id: 'Selamat datang kembali', vi: 'Chào mừng trở lại', th: 'ยินดีต้อนรับกลับ', ja: 'おかえりなさい', ko: '다시 오신 것을 환영합니다' },
  'auth.loginSubtitle': { 'zh-TW': '登入您的 mybonet 帳號', 'zh-CN': '登录您的 mybonet 账号', en: 'Sign in to your mybonet account', id: 'Masuk ke akun mybonet Anda', vi: 'Đăng nhập tài khoản mybonet', th: 'เข้าสู่ระบบบัญชี mybonet', ja: 'mybonet アカウントにログイン', ko: 'mybonet 계정으로 로그인' },
  'auth.createTitle': { 'zh-TW': '建立帳號', 'zh-CN': '建立账号', en: 'Create account', id: 'Buat akun', vi: 'Tạo tài khoản', th: 'สร้างบัญชี', ja: 'アカウント作成', ko: '계정 만들기' },
  'auth.registerSubtitle': { 'zh-TW': '請先完成 Email 驗證後再建立帳號', 'zh-CN': '请先完成邮箱验证后再建立账号', en: 'Verify your email before creating an account', id: 'Verifikasi email sebelum membuat akun', vi: 'Xác minh email trước khi tạo tài khoản', th: 'ยืนยันอีเมลก่อนสร้างบัญชี', ja: 'アカウント作成前にメール認証を完了してください', ko: '계정 만들기 전에 이메일을 인증하세요' },
  'auth.forgot': { 'zh-TW': '忘記密碼？', 'zh-CN': '忘记密码？', en: 'Forgot password?', id: 'Lupa kata sandi?', vi: 'Quên mật khẩu?', th: 'ลืมรหัสผ่าน?', ja: 'パスワードをお忘れですか？', ko: '비밀번호를 잊으셨나요?' },
  'auth.noAccount': { 'zh-TW': '還沒有帳號？立即註冊', 'zh-CN': '还没有账号？立即注册', en: 'No account? Register', id: 'Belum punya akun? Daftar', vi: 'Chưa có tài khoản? Đăng ký', th: 'ยังไม่มีบัญชี? สมัคร', ja: 'アカウント未作成？登録', ko: '계정이 없나요? 가입' },
  'auth.hasAccount': { 'zh-TW': '已有帳號？登入', 'zh-CN': '已有账号？登录', en: 'Have an account? Sign in', id: 'Sudah punya akun? Masuk', vi: 'Đã có tài khoản? Đăng nhập', th: 'มีบัญชีแล้ว? เข้าสู่ระบบ', ja: 'アカウントあり？ログイン', ko: '계정이 있나요? 로그인' },
  'auth.orSocial': { 'zh-TW': '或以社群帳號登入', 'zh-CN': '或以社交账号登录', en: 'Or continue with', id: 'Atau lanjut dengan', vi: 'Hoặc tiếp tục với', th: 'หรือดำเนินการด้วย', ja: 'またはソーシャルで続行', ko: '또는 소셜로 계속' },
  'auth.forgotTitle': { 'zh-TW': '重設密碼', 'zh-CN': '重置密码', en: 'Reset password', id: 'Reset kata sandi', vi: 'Đặt lại mật khẩu', th: 'รีเซ็ตรหัสผ่าน', ja: 'パスワード再設定', ko: '비밀번호 재설정' },
  'auth.forgotSubtitle': { 'zh-TW': '輸入 Email，我們會寄送重設指引（示範）', 'zh-CN': '输入 Email，我们会寄送重置指引（示范）', en: 'Enter email for reset instructions (demo)', id: 'Masukkan email untuk instruksi reset (demo)', vi: 'Nhập email để nhận hướng dẫn (demo)', th: 'กรอกอีเมลเพื่อรับคำแนะนำ (เดโม)', ja: 'メールを入力（デモ）', ko: '이메일을 입력하세요 (데모)' },
  'auth.sendReset': { 'zh-TW': '送出', 'zh-CN': '送出', en: 'Send', id: 'Kirim', vi: 'Gửi', th: 'ส่ง', ja: '送信', ko: '보내기' },
  'auth.backLogin': { 'zh-TW': '回登入', 'zh-CN': '回登录', en: 'Back to sign in', id: 'Kembali masuk', vi: 'Về đăng nhập', th: 'กลับเข้าสู่ระบบ', ja: 'ログインへ戻る', ko: '로그인으로' },
  'auth.verifyTitle': { 'zh-TW': '請查收郵件', 'zh-CN': '请查收邮件', en: 'Check your email', id: 'Cek email Anda', vi: 'Kiểm tra email', th: 'ตรวจสอบอีเมล', ja: 'メールを確認', ko: '이메일을 확인하세요' },
  'auth.verifySubtitle': { 'zh-TW': '示範環境：請返回登入繼續。', 'zh-CN': '示范环境：请返回登录继续。', en: 'Demo: return to sign in to continue.', id: 'Demo: kembali masuk untuk lanjut.', vi: 'Demo: quay lại đăng nhập để tiếp tục.', th: 'เดโม: กลับเข้าสู่ระบบเพื่อดำเนินการต่อ', ja: 'デモ：ログインに戻って続行。', ko: '데모: 로그인으로 돌아가 계속하세요.' },

  'dash.greeting': { 'zh-TW': '你好，', 'zh-CN': '你好，', en: 'Hello, ', id: 'Halo, ', vi: 'Xin chào, ', th: 'สวัสดี, ', ja: 'こんにちは、', ko: '안녕하세요, ' },
  'dash.title': { 'zh-TW': '會員中心', 'zh-CN': '会员中心', en: 'Member console', id: 'Konsol anggota', vi: 'Bảng điều khiển', th: 'ศูนย์สมาชิก', ja: '会員センター', ko: '회원 센터' },
  'dash.sites': { 'zh-TW': '我的網站', 'zh-CN': '我的网站', en: 'My sites', id: 'Situs saya', vi: 'Website của tôi', th: 'เว็บของฉัน', ja: 'マイサイト', ko: '내 사이트' },
  'dash.newSite': { 'zh-TW': '新增網站', 'zh-CN': '新增网站', en: 'New site', id: 'Situs baru', vi: 'Site mới', th: 'เว็บใหม่', ja: 'サイト追加', ko: '사이트 추가' },
  'dash.enterStudio': { 'zh-TW': '進入編輯室', 'zh-CN': '进入编辑室', en: 'Open studio', id: 'Buka studio', vi: 'Vào studio', th: 'เข้าสตูดิโอ', ja: '編集室へ', ko: '편집실 열기' },
  'dash.preview': { 'zh-TW': '預覽前台', 'zh-CN': '预览前台', en: 'Preview', id: 'Pratinjau', vi: 'Xem trước', th: 'ดูตัวอย่าง', ja: 'プレビュー', ko: '미리보기' },
  'dash.quota': { 'zh-TW': '方案額度', 'zh-CN': '方案额度', en: 'Plan quota', id: 'Kuota paket', vi: 'Hạn mức gói', th: 'โควต้าแพ็กเกจ', ja: 'プラン枠', ko: '요금제 한도' },

  'menu.dashboard': { 'zh-TW': '儀表板', 'zh-CN': '仪表板', en: 'Dashboard', id: 'Dasbor', vi: 'Bảng điều khiển', th: 'แดชบอร์ด', ja: 'ダッシュボード', ko: '대시보드' },
  'menu.group.content': { 'zh-TW': '內容管理', 'zh-CN': '内容管理', en: 'Content', id: 'Konten', vi: 'Nội dung', th: 'เนื้อหา', ja: 'コンテンツ', ko: '콘텐츠' },
  'menu.group.commerce': { 'zh-TW': '商務管理', 'zh-CN': '商务管理', en: 'Commerce', id: 'Commerce', vi: 'Thương mại', th: 'พาณิชย์', ja: 'コマース', ko: '커머스' },
  'menu.group.members': { 'zh-TW': '會員管理', 'zh-CN': '会员管理', en: 'Members', id: 'Anggota', vi: 'Thành viên', th: 'สมาชิก', ja: '会員', ko: '회원' },
  'menu.group.settings': { 'zh-TW': '網站設定', 'zh-CN': '网站设置', en: 'Settings', id: 'Pengaturan', vi: 'Cài đặt', th: 'ตั้งค่า', ja: '設定', ko: '설정' },
  'menu.group.ops': { 'zh-TW': '營運工具', 'zh-CN': '运营工具', en: 'Operations', id: 'Operasi', vi: 'Vận hành', th: 'ปฏิบัติการ', ja: '運用', ko: '운영' },
  'menu.content.pages': { 'zh-TW': '頁面管理', 'zh-CN': '页面管理', en: 'Pages', id: 'Halaman', vi: 'Trang', th: 'หน้า', ja: 'ページ', ko: '페이지' },
  'menu.content.pages.all': { 'zh-TW': '所有頁面', 'zh-CN': '所有页面', en: 'All pages', id: 'Semua halaman', vi: 'Tất cả trang', th: 'ทุกหน้า', ja: 'すべてのページ', ko: '모든 페이지' },
  'menu.content.pages.new': { 'zh-TW': '新增頁面', 'zh-CN': '新增页面', en: 'New page', id: 'Halaman baru', vi: 'Trang mới', th: 'หน้าใหม่', ja: '新規ページ', ko: '새 페이지' },
  'menu.content.articles': { 'zh-TW': '文章 / 新聞', 'zh-CN': '文章 / 新闻', en: 'Articles / News', id: 'Artikel / Berita', vi: 'Bài viết / Tin', th: 'บทความ / ข่าว', ja: '記事／ニュース', ko: '기사 / 뉴스' },
  'menu.content.articles.all': { 'zh-TW': '所有文章', 'zh-CN': '所有文章', en: 'All articles', id: 'Semua artikel', vi: 'Tất cả bài', th: 'ทุกบทความ', ja: 'すべての記事', ko: '모든 기사' },
  'menu.content.articles.new': { 'zh-TW': '新增文章', 'zh-CN': '新增文章', en: 'New article', id: 'Artikel baru', vi: 'Bài mới', th: 'บทความใหม่', ja: '新規記事', ko: '새 기사' },
  'menu.content.categories': { 'zh-TW': '分類管理', 'zh-CN': '分类管理', en: 'Categories', id: 'Kategori', vi: 'Danh mục', th: 'หมวดหมู่', ja: 'カテゴリ', ko: '분류' },
  'menu.content.comments': { 'zh-TW': '留言管理', 'zh-CN': '留言管理', en: 'Comments', id: 'Komentar', vi: 'Bình luận', th: 'ความคิดเห็น', ja: 'コメント', ko: '댓글' },
  'menu.content.media': { 'zh-TW': '相簿 / 影音', 'zh-CN': '相册 / 影音', en: 'Media', id: 'Media', vi: 'Media', th: 'สื่อ', ja: 'メディア', ko: '미디어' },
  'menu.content.albums': { 'zh-TW': '相簿管理', 'zh-CN': '相册管理', en: 'Albums', id: 'Album', vi: 'Album', th: 'อัลบั้ม', ja: 'アルバム', ko: '앨범' },
  'menu.content.videos': { 'zh-TW': '影音管理', 'zh-CN': '影音管理', en: 'Videos', id: 'Video', vi: 'Video', th: 'วิดีโอ', ja: '動画', ko: '동영상' },
  'menu.content.mediaLibrary': { 'zh-TW': '媒體庫', 'zh-CN': '媒体库', en: 'Media library', id: 'Pustaka media', vi: 'Thư viện media', th: 'คลังสื่อ', ja: 'メディライブラリ', ko: '미디어 라이브러리' },
  'menu.content.forms': { 'zh-TW': '表單管理', 'zh-CN': '表单管理', en: 'Forms', id: 'Formulir', vi: 'Biểu mẫu', th: 'ฟอร์ม', ja: 'フォーム', ko: '양식' },
  'menu.content.forms.list': { 'zh-TW': '表單列表', 'zh-CN': '表单列表', en: 'Form list', id: 'Daftar formulir', vi: 'Danh sách form', th: 'รายการฟอร์ม', ja: 'フォーム一覧', ko: '양식 목록' },
  'menu.content.forms.replies': { 'zh-TW': '回覆記錄', 'zh-CN': '回复记录', en: 'Submissions', id: 'Kiriman', vi: 'Phản hồi', th: 'การตอบกลับ', ja: '回答記録', ko: '제출 기록' },
  'menu.commerce.products': { 'zh-TW': '商品管理', 'zh-CN': '商品管理', en: 'Products', id: 'Produk', vi: 'Sản phẩm', th: 'สินค้า', ja: '商品', ko: '상품' },
  'menu.commerce.products.all': { 'zh-TW': '商品列表', 'zh-CN': '商品列表', en: 'Product list', id: 'Daftar produk', vi: 'Danh sách SP', th: 'รายการสินค้า', ja: '商品一覧', ko: '상품 목록' },
  'menu.commerce.products.list': { 'zh-TW': '商品列表', 'zh-CN': '商品列表', en: 'Product list', id: 'Daftar produk', vi: 'Danh sách SP', th: 'รายการสินค้า', ja: '商品一覧', ko: '상품 목록' },
  'menu.commerce.products.new': { 'zh-TW': '新增商品', 'zh-CN': '新增商品', en: 'New product', id: 'Produk baru', vi: 'SP mới', th: 'สินค้าใหม่', ja: '新規商品', ko: '새 상품' },
  'menu.commerce.inventory': { 'zh-TW': '庫存管理', 'zh-CN': '库存管理', en: 'Inventory', id: 'Inventaris', vi: 'Tồn kho', th: 'สต็อก', ja: '在庫', ko: '재고' },
  'menu.commerce.categories': { 'zh-TW': '商品分類', 'zh-CN': '商品分类', en: 'Product categories', id: 'Kategori produk', vi: 'Danh mục SP', th: 'หมวดสินค้า', ja: '商品カテゴリ', ko: '상품 분류' },
  'menu.commerce.orders': { 'zh-TW': '訂單管理', 'zh-CN': '订单管理', en: 'Orders', id: 'Pesanan', vi: 'Đơn hàng', th: 'คำสั่งซื้อ', ja: '注文', ko: '주문' },
  'menu.commerce.orders.all': { 'zh-TW': '所有訂單', 'zh-CN': '所有订单', en: 'All orders', id: 'Semua pesanan', vi: 'Tất cả đơn', th: 'ทุกคำสั่งซื้อ', ja: 'すべての注文', ko: '모든 주문' },
  'menu.commerce.orders.pending': { 'zh-TW': '待處理訂單', 'zh-CN': '待处理订单', en: 'Pending orders', id: 'Pesanan pending', vi: 'Đơn chờ', th: 'คำสั่งซื้อรอดำเนินการ', ja: '未処理注文', ko: '대기 주문' },
  'menu.commerce.returns': { 'zh-TW': '退換貨申請', 'zh-CN': '退换货申请', en: 'Returns', id: 'Retur', vi: 'Đổi trả', th: 'คืน/เปลี่ยน', ja: '返品交換', ko: '반품/교환' },
  'menu.commerce.disputes': { 'zh-TW': '爭議處理', 'zh-CN': '争议处理', en: 'Disputes', id: 'Sengketa', vi: 'Tranh chấp', th: 'ข้อพิพาท', ja: '紛争', ko: '분쟁' },
  'menu.commerce.payment': { 'zh-TW': '金流設定', 'zh-CN': '支付设定', en: 'Payments', id: 'Pembayaran', vi: 'Thanh toán', th: 'การชำระเงิน', ja: '決済設定', ko: '결제 설정' },
  'menu.commerce.marketplace': { 'zh-TW': 'Marketplace', 'zh-CN': 'Marketplace', en: 'Marketplace', id: 'Marketplace', vi: 'Marketplace', th: 'Marketplace', ja: 'Marketplace', ko: 'Marketplace' },
  'menu.marketplace.sellers': { 'zh-TW': '賣家管理', 'zh-CN': '卖家管理', en: 'Sellers', id: 'Penjual', vi: 'Người bán', th: 'ผู้ขาย', ja: '出品者', ko: '판매자' },
  'menu.marketplace.escrow': { 'zh-TW': 'Escrow 管理', 'zh-CN': 'Escrow 管理', en: 'Escrow', id: 'Escrow', vi: 'Escrow', th: 'Escrow', ja: 'Escrow', ko: 'Escrow' },
  'menu.marketplace.kyc': { 'zh-TW': 'KYC 審核', 'zh-CN': 'KYC 审核', en: 'KYC', id: 'KYC', vi: 'KYC', th: 'KYC', ja: 'KYC', ko: 'KYC' },
  'menu.marketplace.risk': { 'zh-TW': '風控管理', 'zh-CN': '风控管理', en: 'Risk', id: 'Risiko', vi: 'Rủi ro', th: 'ความเสี่ยง', ja: 'リスク', ko: '리스크' },
  'menu.members': { 'zh-TW': '會員管理', 'zh-CN': '会员管理', en: 'Members', id: 'Anggota', vi: 'Thành viên', th: 'สมาชิก', ja: '会員', ko: '회원' },
  'menu.members.list': { 'zh-TW': '會員列表', 'zh-CN': '会员列表', en: 'Member list', id: 'Daftar anggota', vi: 'Danh sách TV', th: 'รายชื่อสมาชิก', ja: '会員一覧', ko: '회원 목록' },
  'menu.members.groups': { 'zh-TW': '會員群組', 'zh-CN': '会员群组', en: 'Groups', id: 'Grup', vi: 'Nhóm', th: 'กลุ่ม', ja: 'グループ', ko: '그룹' },
  'menu.members.permissions': { 'zh-TW': '權限設定', 'zh-CN': '权限设定', en: 'Permissions', id: 'Izin', vi: 'Quyền', th: 'สิทธิ์', ja: '権限', ko: '권한' },
  'menu.settings.theme': { 'zh-TW': '主題設計', 'zh-CN': '主题设计', en: 'Theme', id: 'Tema', vi: 'Theme', th: 'ธีม', ja: 'テーマ', ko: '테마' },
  'menu.settings.domain': { 'zh-TW': '網域 / SSL', 'zh-CN': '域名 / SSL', en: 'Domain / SSL', id: 'Domain / SSL', vi: 'Domain / SSL', th: 'โดเมน / SSL', ja: 'ドメイン / SSL', ko: '도메인 / SSL' },
  'menu.settings.admins': { 'zh-TW': '管理員帳號', 'zh-CN': '管理员账号', en: 'Admins', id: 'Admin', vi: 'Quản trị', th: 'ผู้ดูแล', ja: '管理者', ko: '관리자' },
  'menu.settings.general': { 'zh-TW': '網站基本設定', 'zh-CN': '网站基本设定', en: 'Site settings', id: 'Pengaturan situs', vi: 'Cài đặt site', th: 'ตั้งค่าไซต์', ja: 'サイト設定', ko: '사이트 설정' },
  'menu.ops.ship': { 'zh-TW': '物流出貨', 'zh-CN': '物流出货', en: 'Shipping', id: 'Pengiriman', vi: 'Vận chuyển', th: 'การจัดส่ง', ja: '出荷', ko: '출고' },
  'menu.ops.aftersale': { 'zh-TW': '售後與爭議', 'zh-CN': '售后与争议', en: 'After-sale', id: 'Purna jual', vi: 'Hậu mãi', th: 'หลังการขาย', ja: 'アフター', ko: '애프터서비스' },
  'menu.ops.hr': { 'zh-TW': '人資班表', 'zh-CN': '人资班表', en: 'HR', id: 'HR', vi: 'Nhân sự', th: 'HR', ja: '人事', ko: '인사' },
  'menu.ops.wallet': { 'zh-TW': '錢包點數', 'zh-CN': '钱包点数', en: 'Wallet', id: 'Dompet', vi: 'Ví', th: 'กระเป๋า', ja: 'ウォレット', ko: '지갑' },
  'menu.ops.workflow': { 'zh-TW': '簽核流程', 'zh-CN': '签核流程', en: 'Workflow', id: 'Alur kerja', vi: 'Quy trình', th: 'เวิร์กโฟลว์', ja: 'ワークフロー', ko: '워크플로' },
  'menu.ops.modules': { 'zh-TW': '模組開關', 'zh-CN': '模块开关', en: 'Modules', id: 'Modul', vi: 'Module', th: 'โมดูล', ja: 'モジュール', ko: '모듈' },
  'menu.ops.design': { 'zh-TW': '設計引擎', 'zh-CN': '设计引擎', en: 'Design engine', id: 'Mesin desain', vi: 'Design engine', th: 'เครื่องมือออกแบบ', ja: 'デザインエンジン', ko: '디자인 엔진' },
  'menu.ops.prompt': { 'zh-TW': 'Prompt 修改', 'zh-CN': 'Prompt 修改', en: 'Prompt edit', id: 'Edit prompt', vi: 'Sửa prompt', th: 'แก้ Prompt', ja: 'Prompt 編集', ko: 'Prompt 수정' },
}
